import { mergeMap, catchError } from 'rxjs/operators';
import { throwError, of, Observable } from 'rxjs';
import * as i0 from '@angular/core';
import { InjectionToken, Injectable, Inject, Optional } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders, HttpResponseBase, HttpResponse, HttpClient } from '@angular/common/http';

//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
const API_BASE_URL = new InjectionToken('API_BASE_URL');
class AppointmentClient {
    constructor(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }
    /**
     * Поиск записи на услугу по специальному ключу
     * @param key Ключ
     * @return Success
     */
    getAppointment(key) {
        let url_ = this.baseUrl + "/api/appointment/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetAppointment(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppointment(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetAppointment(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Отмена любой записи на услугу (сделанную через сайт или другие регистраторы)
     * @param body (optional) Команда, содержащая данные о записи, которую нужно отменить
     * @return Success
     */
    cancelAppointment(body) {
        let url_ = this.baseUrl + "/api/appointment/cancel";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processCancelAppointment(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelAppointment(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processCancelAppointment(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return of(null);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получение специальностей врачей для фильтра страницы "Запись к врачу".
     * @param cityId (optional) Идентификатор города
     * @return Success
     */
    getSpecialities(cityId) {
        let url_ = this.baseUrl + "/api/appointment/specialities?";
        if (cityId === null)
            throw new Error("The parameter 'cityId' cannot be null.");
        else if (cityId !== undefined)
            url_ += "cityId=" + encodeURIComponent("" + cityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetSpecialities(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpecialities(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetSpecialities(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получение врачей, доступных для записи в соответствии с фильтром страницы "Запись к врачу".
     * @param cityId (optional) Идентификатор города
     * @param date Дата записи
     * @param specialityCode Код специальности
     * @param isChildPractitioner (optional) Признак детского врача
     * @param accountCodes (optional) Фильтр по кодам ДЦ
     * @return Success
     */
    getPractitioners(cityId, date, specialityCode, isChildPractitioner, accountCodes) {
        let url_ = this.baseUrl + "/api/appointment/practitioners?";
        if (cityId === null)
            throw new Error("The parameter 'cityId' cannot be null.");
        else if (cityId !== undefined)
            url_ += "cityId=" + encodeURIComponent("" + cityId) + "&";
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined and cannot be null.");
        else
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (specialityCode === undefined || specialityCode === null)
            throw new Error("The parameter 'specialityCode' must be defined and cannot be null.");
        else
            url_ += "specialityCode=" + encodeURIComponent("" + specialityCode) + "&";
        if (isChildPractitioner !== undefined && isChildPractitioner !== null)
            url_ += "isChildPractitioner=" + encodeURIComponent("" + isChildPractitioner) + "&";
        if (accountCodes !== undefined && accountCodes !== null)
            accountCodes && accountCodes.forEach(item => { url_ += "accountCodes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetPractitioners(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPractitioners(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetPractitioners(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получение информации и слотов для записи в каждом центре,
    в котором принимает врач по указанной услуге.
     * @param date Дата приема
     * @param practitionerCode Код врача
     * @param duration (optional) Продолжительность приема
     * @param accountCodes (optional) Фильтр по кодам ДЦ
     * @return Success
     */
    getPractitionerServiceAvailableCenters(date, practitionerCode, duration, accountCodes) {
        let url_ = this.baseUrl + "/api/appointment/practitioners/slots?";
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined and cannot be null.");
        else
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (practitionerCode === undefined || practitionerCode === null)
            throw new Error("The parameter 'practitionerCode' must be defined and cannot be null.");
        else
            url_ += "practitionerCode=" + encodeURIComponent("" + practitionerCode) + "&";
        if (duration === null)
            throw new Error("The parameter 'duration' cannot be null.");
        else if (duration !== undefined)
            url_ += "duration=" + encodeURIComponent("" + duration) + "&";
        if (accountCodes !== undefined && accountCodes !== null)
            accountCodes && accountCodes.forEach(item => { url_ += "accountCodes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetPractitionerServiceAvailableCenters(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPractitionerServiceAvailableCenters(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetPractitionerServiceAvailableCenters(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Создание предзаказа для посещения врача.
     * @param body (optional) Данные для записи к врачу
     * @return Success
     */
    makeAppointment(body) {
        let url_ = this.baseUrl + "/api/appointment/make";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processMakeAppointment(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMakeAppointment(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processMakeAppointment(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AppointmentClient, deps: [{ token: HttpClient }, { token: API_BASE_URL, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AppointmentClient }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AppointmentClient, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient, decorators: [{
                    type: Inject,
                    args: [HttpClient]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API_BASE_URL]
                }] }]; } });
class AuthorizationClient {
    constructor(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }
    /**
     * Авторизация клиента на сайте (куки не проставляются)
     * @param body (optional) Авторизационные данные клиента
     * @return Success
     */
    enter(body) {
        let url_ = this.baseUrl + "/api/authorization/enter";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processEnter(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnter(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processEnter(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AuthorizationClient, deps: [{ token: HttpClient }, { token: API_BASE_URL, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AuthorizationClient }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AuthorizationClient, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient, decorators: [{
                    type: Inject,
                    args: [HttpClient]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API_BASE_URL]
                }] }]; } });
class B2BClient {
    constructor(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }
    /**
     * Отправка формы "Сотрудничество с Хеликс"
     * @param body (optional)
     * @return No Content
     */
    sendB2BPartnershipFeedback(body) {
        let url_ = this.baseUrl + "/api/b2b/partnershipFeedback";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processSendB2BPartnershipFeedback(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendB2BPartnershipFeedback(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processSendB2BPartnershipFeedback(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return of(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Отправка формы "Сотрудничество со страховыми компаниями"
     * @param body (optional)
     * @return No Content
     */
    sendB2BInsuranceFeedback(body) {
        let url_ = this.baseUrl + "/api/b2b/insuranceFeedback";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processSendB2BInsuranceFeedback(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendB2BInsuranceFeedback(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processSendB2BInsuranceFeedback(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return of(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Отправка формы "LabPass"
     * @param body (optional)
     * @return No Content
     */
    sendB2BLabPassFeedback(body) {
        let url_ = this.baseUrl + "/api/b2b/labpassFeedback";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processSendB2BLabPassFeedback(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendB2BLabPassFeedback(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processSendB2BLabPassFeedback(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return of(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: B2BClient, deps: [{ token: HttpClient }, { token: API_BASE_URL, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: B2BClient }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: B2BClient, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient, decorators: [{
                    type: Inject,
                    args: [HttpClient]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API_BASE_URL]
                }] }]; } });
class BusinessClient {
    constructor(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }
    /**
     * Получить список всех партнеров для b2b
     * @return Success
     */
    getAllPartners() {
        let url_ = this.baseUrl + "/api/business/partners";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetAllPartners(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPartners(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetAllPartners(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BusinessClient, deps: [{ token: HttpClient }, { token: API_BASE_URL, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BusinessClient }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BusinessClient, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient, decorators: [{
                    type: Inject,
                    args: [HttpClient]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API_BASE_URL]
                }] }]; } });
class CacheClient {
    constructor(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }
    /**
     * Получить текущий статус кэша
     * @return Success
     */
    get(cache) {
        let url_ = this.baseUrl + "/api/cache/{cache}";
        if (cache === undefined || cache === null)
            throw new Error("The parameter 'cache' must be defined.");
        url_ = url_.replace("{cache}", encodeURIComponent("" + cache));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGet(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGet(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Запустить работу кэша
     * @return Success
     */
    start(cache) {
        let url_ = this.baseUrl + "/api/cache/{cache}/start";
        if (cache === undefined || cache === null)
            throw new Error("The parameter 'cache' must be defined.");
        url_ = url_.replace("{cache}", encodeURIComponent("" + cache));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processStart(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStart(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processStart(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Сбросить текущее содержимое кэша
     * @return Success
     */
    reset(cache) {
        let url_ = this.baseUrl + "/api/cache/{cache}/reset";
        if (cache === undefined || cache === null)
            throw new Error("The parameter 'cache' must be defined.");
        url_ = url_.replace("{cache}", encodeURIComponent("" + cache));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processReset(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReset(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processReset(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Остановить работу кэша
     * @return Success
     */
    stop(cache) {
        let url_ = this.baseUrl + "/api/cache/{cache}/stop";
        if (cache === undefined || cache === null)
            throw new Error("The parameter 'cache' must be defined.");
        url_ = url_.replace("{cache}", encodeURIComponent("" + cache));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processStop(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStop(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processStop(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CacheClient, deps: [{ token: HttpClient }, { token: API_BASE_URL, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CacheClient }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CacheClient, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient, decorators: [{
                    type: Inject,
                    args: [HttpClient]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API_BASE_URL]
                }] }]; } });
class CartClient {
    constructor(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }
    /**
     * Получить количество анализов в корзине
     * @return Success
     */
    getCartItemsCount() {
        let url_ = this.baseUrl + "/api/cart/items/count";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetCartItemsCount(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCartItemsCount(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetCartItemsCount(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получить список hxid-ов анализов в корзине
     * @return Success
     */
    getCartItemsHxids() {
        let url_ = this.baseUrl + "/api/cart/items/hxids";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetCartItemsHxids(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCartItemsHxids(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetCartItemsHxids(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Добавляет анализ в корзину с проверкой возможности добавления
    (кроме тех, что должны быть доступны только по записи)
     * @param body (optional) Содержит hxid анализа
     * @return Success
     */
    addItemToCartWithConfirmation(body) {
        let url_ = this.baseUrl + "/api/cart/items/confirmation";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processAddItemToCartWithConfirmation(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddItemToCartWithConfirmation(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processAddItemToCartWithConfirmation(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Добавляет несколько анализов в корзину. Есть ограничение на максимальное количество анализов
     * @param body (optional) Содержит список hxid анализов и другие данные
     * @return Success
     */
    addItemsToCart(body) {
        let url_ = this.baseUrl + "/api/cart/items/bulk";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processAddItemsToCart(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddItemsToCart(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processAddItemsToCart(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Добавляет анализ в корзину (кроме тех, что должны быть доступны
    только по записи)
     * @param body (optional) Содержит hxid анализа
     * @return No Content
     */
    addItemToCart(body) {
        let url_ = this.baseUrl + "/api/cart/items";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processAddItemToCart(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddItemToCart(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processAddItemToCart(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return of(null);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Удаляет позицию из корзины
     * @param cartItemId Идентификатор анализа
     * @return Success
     */
    removeCartItem(cartItemId) {
        let url_ = this.baseUrl + "/api/cart/items/delete/{cartItemId}";
        if (cartItemId === undefined || cartItemId === null)
            throw new Error("The parameter 'cartItemId' must be defined.");
        url_ = url_.replace("{cartItemId}", encodeURIComponent("" + cartItemId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processRemoveCartItem(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveCartItem(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processRemoveCartItem(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Сохраняет выбранное из селектора правило
     * @param body Содержит идентификатор анализа и идентификатор выбранного правила
     * @return No Content
     */
    setChoosenRule(body) {
        let url_ = this.baseUrl + "/api/cart/items/rule";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processSetChoosenRule(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetChoosenRule(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processSetChoosenRule(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return of(null);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Удаляет услугу из корзины
     * @param body (optional) Данные об услуге
     * @return No Content
     */
    removeServiceFromCart(body) {
        let url_ = this.baseUrl + "/api/cart/services/delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processRemoveServiceFromCart(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveServiceFromCart(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processRemoveServiceFromCart(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status === 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return of(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Удаляет контейнер из корзины
     * @param body (optional) Данные об услуге-контейнере
     * @return No Content
     * @deprecated
     */
    removeContainer(body) {
        let url_ = this.baseUrl + "/api/cart/services/container";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processRemoveContainer(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveContainer(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processRemoveContainer(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status === 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return of(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получить информацию о корзине
     * @param cityId Идентификатор региона
     * @return Success
     */
    getCartInfo(cityId) {
        let url_ = this.baseUrl + "/api/cart/info/{cityId}";
        if (cityId === undefined || cityId === null)
            throw new Error("The parameter 'cityId' must be defined.");
        url_ = url_.replace("{cityId}", encodeURIComponent("" + cityId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetCartInfo(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCartInfo(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetCartInfo(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("No Content", status, _responseText, _headers);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Возвращает данные предзаказа для проверки
     * @param cityId Идентификатор города
     * @return Success
     */
    getFullCartInfo(cityId) {
        let url_ = this.baseUrl + "/api/cart/info/full/{cityId}";
        if (cityId === undefined || cityId === null)
            throw new Error("The parameter 'cityId' must be defined.");
        url_ = url_.replace("{cityId}", encodeURIComponent("" + cityId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetFullCartInfo(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFullCartInfo(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetFullCartInfo(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("No Content", status, _responseText, _headers);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Сохраняет данные клиента, на которого оформляется предзаказ
     * @return Success
     */
    saveCartCustomerInfo(body) {
        let url_ = this.baseUrl + "/api/cart/customer";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processSaveCartCustomerInfo(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveCartCustomerInfo(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processSaveCartCustomerInfo(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("No Content", status, _responseText, _headers);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получает данные клиента в корзине и дополнительную информацию о профилях его учётной записи
    (если клиент авторизован)
     * @param cityId Идентификатор города
     * @return Success
     */
    getCartCustomersInfo(cityId) {
        let url_ = this.baseUrl + "/api/cart/customers?";
        if (cityId === undefined || cityId === null)
            throw new Error("The parameter 'cityId' must be defined and cannot be null.");
        else
            url_ += "cityId=" + encodeURIComponent("" + cityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetCartCustomersInfo(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCartCustomersInfo(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetCartCustomersInfo(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("No Content", status, _responseText, _headers);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Завершает создание предзаказа
     * @param body (optional) Содержит параметры, необходимые для завершения оформления ПЗ
     * @return Success
     */
    completeCart(body) {
        let url_ = this.baseUrl + "/api/cart/complete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processCompleteCart(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteCart(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processCompleteCart(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Удаляет корзину
     * @param webAccountId (optional) Идентификатор аккаунта, для которого будет очищена корзина
     * @return No Content
     */
    removeCart(webAccountId) {
        let url_ = this.baseUrl + "/api/cart/delete/{webAccountId}";
        if (webAccountId !== null && webAccountId !== undefined)
            url_ = url_.replace("{webAccountId}", encodeURIComponent("" + webAccountId));
        else
            url_ = url_.replace("/{webAccountId}", "");
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processRemoveCart(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveCart(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processRemoveCart(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return of(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получает URL ссылку на страницу оплаты услуг, находящихся в корзине
     * @param cityId Идентификатор города
     * @param clientId Яндекс Метрика Id пользователя сайта, от имени которого будет отправлено событие
     * @param counterId Номер счетчика Яндекс метрики
     * @return Success
     */
    getHelixLiteCheckoutLink(cityId, clientId, counterId) {
        let url_ = this.baseUrl + "/api/cart/helixlite/checkout-link?";
        if (cityId === undefined || cityId === null)
            throw new Error("The parameter 'cityId' must be defined and cannot be null.");
        else
            url_ += "cityId=" + encodeURIComponent("" + cityId) + "&";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined and cannot be null.");
        else
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (counterId === undefined || counterId === null)
            throw new Error("The parameter 'counterId' must be defined and cannot be null.");
        else
            url_ += "counterId=" + encodeURIComponent("" + counterId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetHelixLiteCheckoutLink(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHelixLiteCheckoutLink(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetHelixLiteCheckoutLink(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Отправляет запрос в яндекс метрику и удаляет корзину
     * @param webAccountId (optional) Аккаунт для удаления корзины
     * @param clientId (optional) Id клиента Яндекс метрики
     * @param counterId (optional) Id счетчика offline-конверсии
     */
    getHelixLiteCompleteCheckout(webAccountId, clientId, counterId) {
        let url_ = this.baseUrl + "/api/cart/helixlite/complete-checkout?";
        if (webAccountId === null)
            throw new Error("The parameter 'webAccountId' cannot be null.");
        else if (webAccountId !== undefined)
            url_ += "webAccountId=" + encodeURIComponent("" + webAccountId) + "&";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (counterId === null)
            throw new Error("The parameter 'counterId' cannot be null.");
        else if (counterId !== undefined)
            url_ += "counterId=" + encodeURIComponent("" + counterId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({})
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetHelixLiteCompleteCheckout(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHelixLiteCompleteCheckout(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetHelixLiteCompleteCheckout(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CartClient, deps: [{ token: HttpClient }, { token: API_BASE_URL, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CartClient }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CartClient, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient, decorators: [{
                    type: Inject,
                    args: [HttpClient]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API_BASE_URL]
                }] }]; } });
class CatalogClient {
    constructor(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }
    /**
     * Возвращает пример результатов анализа.
     * @param hxid (optional) HXID анализа.
     * @return Success
     */
    downloadExampleFile(hxid) {
        let url_ = this.baseUrl + "/api/catalog/downloadexamplefile?";
        if (hxid === null)
            throw new Error("The parameter 'hxid' cannot be null.");
        else if (hxid !== undefined)
            url_ += "hxid=" + encodeURIComponent("" + hxid) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processDownloadExampleFile(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadExampleFile(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processDownloadExampleFile(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return of({ fileName: fileName, data: responseBlob, status: status, headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получить полную информацию о номенклатуре в городе
    WARNING: Используется в Helix Mobile App
     * @param hxid Идентификатор Номенклатуры
     * @param city Название города
     * @return Success
     * @deprecated
     */
    getNomenclature(hxid, city) {
        let url_ = this.baseUrl + "/api/catalog/{hxid}/{city}";
        if (hxid === undefined || hxid === null)
            throw new Error("The parameter 'hxid' must be defined.");
        url_ = url_.replace("{hxid}", encodeURIComponent("" + hxid));
        if (city === undefined || city === null)
            throw new Error("The parameter 'city' must be defined.");
        url_ = url_.replace("{city}", encodeURIComponent("" + city));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetNomenclature(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNomenclature(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetNomenclature(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получить полную информацию о номенклатуре в городе
     * @param hxid Идентификатор Номенклатуры
     * @param cityId Id города
     * @return Success
     */
    getNomenclatureWithCityId(hxid, cityId) {
        let url_ = this.baseUrl + "/api/catalog/{hxid}/{cityId}";
        if (hxid === undefined || hxid === null)
            throw new Error("The parameter 'hxid' must be defined.");
        url_ = url_.replace("{hxid}", encodeURIComponent("" + hxid));
        if (cityId === undefined || cityId === null)
            throw new Error("The parameter 'cityId' must be defined.");
        url_ = url_.replace("{cityId}", encodeURIComponent("" + cityId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetNomenclatureWithCityId(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNomenclatureWithCityId(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetNomenclatureWithCityId(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получает краткую информацию об анализах
     * @param body (optional) Модержит список анализов и город, для которого нужно получить информацию
     * @return Success
     * @deprecated
     */
    getNomenclatureSimpleList(body) {
        let url_ = this.baseUrl + "/api/catalog/nomenclatures";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetNomenclatureSimpleList(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNomenclatureSimpleList(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetNomenclatureSimpleList(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получает краткую информацию об анализах
     * @param cityId Id города
     * @param hxids Список id анализов
     * @return Success
     */
    getNomenclatures(cityId, hxids) {
        let url_ = this.baseUrl + "/api/catalog/nomenclatures/{cityId}?";
        if (cityId === undefined || cityId === null)
            throw new Error("The parameter 'cityId' must be defined.");
        url_ = url_.replace("{cityId}", encodeURIComponent("" + cityId));
        if (hxids === undefined || hxids === null)
            throw new Error("The parameter 'hxids' must be defined and cannot be null.");
        else
            hxids && hxids.forEach(item => { url_ += "hxids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetNomenclatures(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNomenclatures(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetNomenclatures(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получает номенклатуры по группе (пока используется только для сводной ковидной страницы)
     * @param body (optional)
     * @return Success
     * @deprecated
     */
    getNomenclaturesByGroup(body) {
        let url_ = this.baseUrl + "/api/catalog/group";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetNomenclaturesByGroup(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNomenclaturesByGroup(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetNomenclaturesByGroup(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получает номенклатуры по группе (пока используется только для сводной ковидной страницы)
     * @param cityId Id города
     * @param groupType Группа на ковидной странице
     * @return Success
     */
    getNomenclaturesByGroupV2(cityId, groupType) {
        let url_ = this.baseUrl + "/api/catalog/group/{cityId}?";
        if (cityId === undefined || cityId === null)
            throw new Error("The parameter 'cityId' must be defined.");
        url_ = url_.replace("{cityId}", encodeURIComponent("" + cityId));
        if (groupType === undefined || groupType === null)
            throw new Error("The parameter 'groupType' must be defined and cannot be null.");
        else
            url_ += "groupType=" + encodeURIComponent("" + groupType) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetNomenclaturesByGroupV2(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNomenclaturesByGroupV2(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetNomenclaturesByGroupV2(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получить список номенклатур с ценами по городу для страницы оферты, отсортированный по hxid
     * @return Success
     */
    getOfferPrices(cityId) {
        let url_ = this.baseUrl + "/api/catalog/prices/offer?";
        if (cityId === undefined || cityId === null)
            throw new Error("The parameter 'cityId' must be defined and cannot be null.");
        else
            url_ += "cityId=" + encodeURIComponent("" + cityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetOfferPrices(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOfferPrices(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetOfferPrices(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("No Content", status, _responseText, _headers);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получить доступность номенклатуры в Helix Express
     * @param cityId (optional)
     * @param hxids (optional)
     * @return Success
     */
    getHelixExpressAvailability(cityId, hxids) {
        let url_ = this.baseUrl + "/api/catalog/helixExpress?";
        if (cityId === null)
            throw new Error("The parameter 'cityId' cannot be null.");
        else if (cityId !== undefined)
            url_ += "cityId=" + encodeURIComponent("" + cityId) + "&";
        if (hxids === null)
            throw new Error("The parameter 'hxids' cannot be null.");
        else if (hxids !== undefined)
            hxids && hxids.forEach(item => { url_ += "hxids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetHelixExpressAvailability(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHelixExpressAvailability(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetHelixExpressAvailability(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получить список популярных номенклатур
     * @param cityId Id города
     * @return Success
     */
    getPopularItems(cityId) {
        let url_ = this.baseUrl + "/api/catalog/popular-items/{cityId}";
        if (cityId === undefined || cityId === null)
            throw new Error("The parameter 'cityId' must be defined.");
        url_ = url_.replace("{cityId}", encodeURIComponent("" + cityId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetPopularItems(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPopularItems(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetPopularItems(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("No Content", status, _responseText, _headers);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получить категории анализов для каталога
     * @return Success
     */
    getCatalogCategories() {
        let url_ = this.baseUrl + "/api/catalog/categories";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetCatalogCategories(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCatalogCategories(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetCatalogCategories(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получить атрибуты категории для каталога
     * @return Success
     */
    getCatalogCategoryAttributes(cityId, categoryId) {
        let url_ = this.baseUrl + "/api/catalog/categories/attributes?";
        if (cityId === undefined || cityId === null)
            throw new Error("The parameter 'cityId' must be defined and cannot be null.");
        else
            url_ += "cityId=" + encodeURIComponent("" + cityId) + "&";
        if (categoryId === undefined || categoryId === null)
            throw new Error("The parameter 'categoryId' must be defined and cannot be null.");
        else
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetCatalogCategoryAttributes(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCatalogCategoryAttributes(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetCatalogCategoryAttributes(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получить список анализов для каталога по категории и фильтрам
     * @return Success
     * @deprecated
     */
    getCatalogListItemsOld(body) {
        let url_ = this.baseUrl + "/api/catalog/items/list";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetCatalogListItemsOld(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCatalogListItemsOld(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetCatalogListItemsOld(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получить список анализов для каталога по категории и фильтрам
     * @param cityId (optional)
     * @param filter_categoryId (optional)
     * @param filter_attributeIds (optional)
     * @param pagination_lastId (optional)
     * @param pagination_itemCount (optional)
     * @return Success
     * @deprecated
     */
    getCatalogListItems(cityId, filter_categoryId, filter_attributeIds, pagination_lastId, pagination_itemCount) {
        let url_ = this.baseUrl + "/api/catalog/items/list?";
        if (cityId === null)
            throw new Error("The parameter 'cityId' cannot be null.");
        else if (cityId !== undefined)
            url_ += "cityId=" + encodeURIComponent("" + cityId) + "&";
        if (filter_categoryId === null)
            throw new Error("The parameter 'filter_categoryId' cannot be null.");
        else if (filter_categoryId !== undefined)
            url_ += "filter.categoryId=" + encodeURIComponent("" + filter_categoryId) + "&";
        if (filter_attributeIds === null)
            throw new Error("The parameter 'filter_attributeIds' cannot be null.");
        else if (filter_attributeIds !== undefined)
            filter_attributeIds && filter_attributeIds.forEach(item => { url_ += "filter.attributeIds=" + encodeURIComponent("" + item) + "&"; });
        if (pagination_lastId === null)
            throw new Error("The parameter 'pagination_lastId' cannot be null.");
        else if (pagination_lastId !== undefined)
            url_ += "pagination.lastId=" + encodeURIComponent("" + pagination_lastId) + "&";
        if (pagination_itemCount === null)
            throw new Error("The parameter 'pagination_itemCount' cannot be null.");
        else if (pagination_itemCount !== undefined)
            url_ += "pagination.itemCount=" + encodeURIComponent("" + pagination_itemCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetCatalogListItems(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCatalogListItems(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetCatalogListItems(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получить список анализов для каталога по категории и фильтрам
     * @param cityId (optional)
     * @param filter_categoryId (optional)
     * @param filter_attributeIds (optional)
     * @param pagination_take (optional)
     * @param pagination_skip (optional)
     * @return Success
     */
    getCatalogListItemsV2(cityId, filter_categoryId, filter_attributeIds, pagination_take, pagination_skip) {
        let url_ = this.baseUrl + "/api/catalog/items/list/v2?";
        if (cityId === null)
            throw new Error("The parameter 'cityId' cannot be null.");
        else if (cityId !== undefined)
            url_ += "cityId=" + encodeURIComponent("" + cityId) + "&";
        if (filter_categoryId === null)
            throw new Error("The parameter 'filter_categoryId' cannot be null.");
        else if (filter_categoryId !== undefined)
            url_ += "filter.categoryId=" + encodeURIComponent("" + filter_categoryId) + "&";
        if (filter_attributeIds === null)
            throw new Error("The parameter 'filter_attributeIds' cannot be null.");
        else if (filter_attributeIds !== undefined)
            filter_attributeIds && filter_attributeIds.forEach(item => { url_ += "filter.attributeIds=" + encodeURIComponent("" + item) + "&"; });
        if (pagination_take === null)
            throw new Error("The parameter 'pagination_take' cannot be null.");
        else if (pagination_take !== undefined)
            url_ += "pagination.take=" + encodeURIComponent("" + pagination_take) + "&";
        if (pagination_skip === null)
            throw new Error("The parameter 'pagination_skip' cannot be null.");
        else if (pagination_skip !== undefined)
            url_ += "pagination.skip=" + encodeURIComponent("" + pagination_skip) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetCatalogListItemsV2(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCatalogListItemsV2(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetCatalogListItemsV2(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получить детальную информацию для категории (текст располагается внизу страницы категории)
     * @param categoryId (optional)
     * @return Success
     */
    getCatalogCategoryDetailedInfo(categoryId) {
        let url_ = this.baseUrl + "/api/catalog/categoryDetailedInfo?";
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetCatalogCategoryDetailedInfo(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCatalogCategoryDetailedInfo(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetCatalogCategoryDetailedInfo(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CatalogClient, deps: [{ token: HttpClient }, { token: API_BASE_URL, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CatalogClient }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CatalogClient, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient, decorators: [{
                    type: Inject,
                    args: [HttpClient]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API_BASE_URL]
                }] }]; } });
class CentersClient {
    constructor(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }
    /**
     * Получить центр по коду
     * @param accountCode Id центра
     * @return Success
     */
    getCenter(accountCode) {
        let url_ = this.baseUrl + "/api/centers/{accountCode}";
        if (accountCode === undefined || accountCode === null)
            throw new Error("The parameter 'accountCode' must be defined.");
        url_ = url_.replace("{accountCode}", encodeURIComponent("" + accountCode));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetCenter(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCenter(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetCenter(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получить список центров по городу
     * @param cityId Id города
     * @return Success
     */
    getCenters(cityId) {
        let url_ = this.baseUrl + "/api/centers/all/{cityId}";
        if (cityId === undefined || cityId === null)
            throw new Error("The parameter 'cityId' must be defined.");
        url_ = url_.replace("{cityId}", encodeURIComponent("" + cityId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetCenters(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCenters(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetCenters(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получить количество центров по всем городам
     * @return Success
     */
    getCentersCountByCity() {
        let url_ = this.baseUrl + "/api/centers/all/countByCity";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetCentersCountByCity(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCentersCountByCity(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetCentersCountByCity(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Метод возвращает список станций метро и их кодов в системе 1С.
    Список формируется на основе доступных мест взятия биоматериала.
     * @param cityId Идентификатор города
     * @return Success
     */
    getCentersMetros(cityId) {
        let url_ = this.baseUrl + "/api/centers/metros/{cityId}";
        if (cityId === undefined || cityId === null)
            throw new Error("The parameter 'cityId' must be defined.");
        url_ = url_.replace("{cityId}", encodeURIComponent("" + cityId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetCentersMetros(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCentersMetros(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetCentersMetros(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("No Content", status, _responseText, _headers);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получить количество актуальных мест забора по городу
     * @param cityId Id города
     * @return Success
     */
    getCentersCountByCityId(cityId) {
        let url_ = this.baseUrl + "/api/centers/count/{cityId}";
        if (cityId === undefined || cityId === null)
            throw new Error("The parameter 'cityId' must be defined.");
        url_ = url_.replace("{cityId}", encodeURIComponent("" + cityId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetCentersCountByCityId(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCentersCountByCityId(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetCentersCountByCityId(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Возвращает список всех диагностических центров в регионе (доступных по публичному контракту)
    с информацией о них (название, адрес, координаты, ближайшие станции метро и т.д.),
    с информацией о доступном типе оплаты
     * @param cityId Идентификатор региона
     * @param hxids Список HXID для проверки доступности типов оплаты
     * @return Success
     */
    getHxidAvailability(cityId, hxids) {
        let url_ = this.baseUrl + "/api/centers/availability/{cityId}?";
        if (cityId === undefined || cityId === null)
            throw new Error("The parameter 'cityId' must be defined.");
        url_ = url_.replace("{cityId}", encodeURIComponent("" + cityId));
        if (hxids === undefined || hxids === null)
            throw new Error("The parameter 'hxids' must be defined and cannot be null.");
        else
            hxids && hxids.forEach(item => { url_ += "hxids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetHxidAvailability(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHxidAvailability(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetHxidAvailability(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получить список тегов для центров по городу
     * @param cityId Id города
     * @return Success
     */
    getCentersTagsByCityId(cityId) {
        let url_ = this.baseUrl + "/api/centers/tags/{cityId}";
        if (cityId === undefined || cityId === null)
            throw new Error("The parameter 'cityId' must be defined.");
        url_ = url_.replace("{cityId}", encodeURIComponent("" + cityId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetCentersTagsByCityId(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCentersTagsByCityId(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetCentersTagsByCityId(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получить список акций для центра
     * @param accountCode Код центра
     * @return Success
     */
    getCenterPromotions(accountCode) {
        let url_ = this.baseUrl + "/api/centers/promotions/{accountCode}";
        if (accountCode === undefined || accountCode === null)
            throw new Error("The parameter 'accountCode' must be defined.");
        url_ = url_.replace("{accountCode}", encodeURIComponent("" + accountCode));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetCenterPromotions(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCenterPromotions(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetCenterPromotions(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CentersClient, deps: [{ token: HttpClient }, { token: API_BASE_URL, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CentersClient }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CentersClient, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient, decorators: [{
                    type: Inject,
                    args: [HttpClient]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API_BASE_URL]
                }] }]; } });
class CitiesClient {
    constructor(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }
    /**
     * @return Success
     */
    getCities() {
        let url_ = this.baseUrl + "/api/cities";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetCities(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCities(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetCities(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Города с сортировкой для ЛКК (удалить после редизайна ЛКК)
     * @return Success
     * @deprecated
     */
    getLkkCities() {
        let url_ = this.baseUrl + "/api/cities/my";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetLkkCities(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLkkCities(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetLkkCities(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * @return Success
     */
    getCityById(id) {
        let url_ = this.baseUrl + "/api/cities/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetCityById(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCityById(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetCityById(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("No Content", status, _responseText, _headers);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получить текущий город по ip
    WARNING: Используется в Helix Mobile App
     * @param alias (optional)
     * @return Success
     */
    getCurrentUserCity(alias) {
        let url_ = this.baseUrl + "/api/cities/current?";
        if (alias === null)
            throw new Error("The parameter 'alias' cannot be null.");
        else if (alias !== undefined)
            url_ += "alias=" + encodeURIComponent("" + alias) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetCurrentUserCity(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUserCity(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetCurrentUserCity(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * @return Success
     */
    setCurrentUserCity(body) {
        let url_ = this.baseUrl + "/api/cities/current";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processSetCurrentUserCity(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetCurrentUserCity(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processSetCurrentUserCity(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CitiesClient, deps: [{ token: HttpClient }, { token: API_BASE_URL, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CitiesClient }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CitiesClient, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient, decorators: [{
                    type: Inject,
                    args: [HttpClient]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API_BASE_URL]
                }] }]; } });
class ConfigurationClient {
    constructor(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }
    /**
     * Получить основную конфигурацию сайта
     * @return Success
     */
    getConfiguration() {
        let url_ = this.baseUrl + "/api/configuration";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetConfiguration(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfiguration(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetConfiguration(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Конфигурация для ЛКК
     * @param isJustLoggedIn (optional)
     * @return Success
     */
    getMyConfiguration(cityId, isJustLoggedIn) {
        let url_ = this.baseUrl + "/api/configuration/my?";
        if (cityId === undefined || cityId === null)
            throw new Error("The parameter 'cityId' must be defined and cannot be null.");
        else
            url_ += "cityId=" + encodeURIComponent("" + cityId) + "&";
        if (isJustLoggedIn === null)
            throw new Error("The parameter 'isJustLoggedIn' cannot be null.");
        else if (isJustLoggedIn !== undefined)
            url_ += "isJustLoggedIn=" + encodeURIComponent("" + isJustLoggedIn) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetMyConfiguration(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyConfiguration(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetMyConfiguration(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ConfigurationClient, deps: [{ token: HttpClient }, { token: API_BASE_URL, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ConfigurationClient }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ConfigurationClient, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient, decorators: [{
                    type: Inject,
                    args: [HttpClient]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API_BASE_URL]
                }] }]; } });
class DictionaryClient {
    constructor(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }
    /**
     * Список возможных посещённых стран
     * @return Success
     */
    getCountries() {
        let url_ = this.baseUrl + "/api/dictionary/countries";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetCountries(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountries(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetCountries(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DictionaryClient, deps: [{ token: HttpClient }, { token: API_BASE_URL, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DictionaryClient }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DictionaryClient, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient, decorators: [{
                    type: Inject,
                    args: [HttpClient]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API_BASE_URL]
                }] }]; } });
class DynamicsClient {
    constructor(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }
    /**
     * Возвращает названия анализов и их показателей, для которых доступна динамика результатов
     * @return Success
     */
    getTests(profileId) {
        let url_ = this.baseUrl + "/api/dynamics/tests?";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined and cannot be null.");
        else
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetTests(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTests(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetTests(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Возвращает показатели анализа, для которых доступна динамика результатов
     * @return Success
     */
    getIndexes(body) {
        let url_ = this.baseUrl + "/api/dynamics/dynamics";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetIndexes(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIndexes(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetIndexes(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DynamicsClient, deps: [{ token: HttpClient }, { token: API_BASE_URL, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DynamicsClient }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DynamicsClient, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient, decorators: [{
                    type: Inject,
                    args: [HttpClient]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API_BASE_URL]
                }] }]; } });
class FeedbackClient {
    constructor(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }
    /**
     * Отправить письмо с вопросом пользователя
     * @param googleRecaptchaResponse (optional)
     * @param cityId (optional)
     * @param name (optional)
     * @param email (optional)
     * @param messageType (optional) Тип сообщения
     * @param messageSource (optional) Источник сообщения
     * @param message (optional)
     * @param orderCode (optional)
     * @param files (optional)
     * @return Success
     */
    setUserFeedback(googleRecaptchaResponse, cityId, name, email, messageType, messageSource, message, orderCode, files) {
        let url_ = this.baseUrl + "/api/feedback";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (googleRecaptchaResponse === null || googleRecaptchaResponse === undefined)
            throw new Error("The parameter 'googleRecaptchaResponse' cannot be null.");
        else
            content_.append("googleRecaptchaResponse", googleRecaptchaResponse.toString());
        if (cityId === null || cityId === undefined)
            throw new Error("The parameter 'cityId' cannot be null.");
        else
            content_.append("cityId", cityId.toString());
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("name", name.toString());
        if (email === null || email === undefined)
            throw new Error("The parameter 'email' cannot be null.");
        else
            content_.append("email", email.toString());
        if (messageType === null || messageType === undefined)
            throw new Error("The parameter 'messageType' cannot be null.");
        else
            content_.append("messageType", messageType.toString());
        if (messageSource === null || messageSource === undefined)
            throw new Error("The parameter 'messageSource' cannot be null.");
        else
            content_.append("messageSource", messageSource.toString());
        if (message === null || message === undefined)
            throw new Error("The parameter 'message' cannot be null.");
        else
            content_.append("message", message.toString());
        if (orderCode === null || orderCode === undefined)
            throw new Error("The parameter 'orderCode' cannot be null.");
        else
            content_.append("orderCode", orderCode.toString());
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files"));
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processSetUserFeedback(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetUserFeedback(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processSetUserFeedback(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return of(null);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Отправить сообщение об ошибке от пользователя
     * @param googleRecaptchaResponse (optional)
     * @param email (optional)
     * @param bugUrl (optional)
     * @param message (optional)
     * @return Success
     */
    setSiteErrorFeedback(googleRecaptchaResponse, email, bugUrl, message) {
        let url_ = this.baseUrl + "/api/feedback/error";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (googleRecaptchaResponse === null || googleRecaptchaResponse === undefined)
            throw new Error("The parameter 'googleRecaptchaResponse' cannot be null.");
        else
            content_.append("googleRecaptchaResponse", googleRecaptchaResponse.toString());
        if (email === null || email === undefined)
            throw new Error("The parameter 'email' cannot be null.");
        else
            content_.append("email", email.toString());
        if (bugUrl === null || bugUrl === undefined)
            throw new Error("The parameter 'bugUrl' cannot be null.");
        else
            content_.append("bugUrl", bugUrl.toString());
        if (message === null || message === undefined)
            throw new Error("The parameter 'message' cannot be null.");
        else
            content_.append("message", message.toString());
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processSetSiteErrorFeedback(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetSiteErrorFeedback(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processSetSiteErrorFeedback(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return of(null);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Отправить сообщение о записи к врачу
     * @param body Данные для сообщения о записи к врачу
     * @return Success
     */
    setPractitionerFeedback(body) {
        let url_ = this.baseUrl + "/api/feedback/practitioner";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processSetPractitionerFeedback(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetPractitionerFeedback(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processSetPractitionerFeedback(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return of(null);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FeedbackClient, deps: [{ token: HttpClient }, { token: API_BASE_URL, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FeedbackClient }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FeedbackClient, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient, decorators: [{
                    type: Inject,
                    args: [HttpClient]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API_BASE_URL]
                }] }]; } });
class InterviewClient {
    constructor(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }
    /**
     * Отправить результаты опроса в личном кабинете клиента
     * @param body (optional)
     * @return Success
     */
    sendInterview(body) {
        let url_ = this.baseUrl + "/api/interview/my";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processSendInterview(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendInterview(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processSendInterview(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return of(null);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: InterviewClient, deps: [{ token: HttpClient }, { token: API_BASE_URL, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: InterviewClient }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: InterviewClient, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient, decorators: [{
                    type: Inject,
                    args: [HttpClient]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API_BASE_URL]
                }] }]; } });
class JobClient {
    constructor(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }
    /**
     * Список вакансий
     * @return Success
     */
    getJobs(cityId) {
        let url_ = this.baseUrl + "/api/job/getJobs/{cityId}";
        if (cityId === undefined || cityId === null)
            throw new Error("The parameter 'cityId' must be defined.");
        url_ = url_.replace("{cityId}", encodeURIComponent("" + cityId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetJobs(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobs(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetJobs(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Отправить письмо с резюме
     * @param name (optional)
     * @param phone (optional)
     * @param email (optional)
     * @param message (optional)
     * @param file (optional)
     * @param googleRecaptchaResponse (optional)
     * @return Success
     */
    applyJob(name, phone, email, message, file, googleRecaptchaResponse) {
        let url_ = this.baseUrl + "/api/job/applyJob";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("name", name.toString());
        if (phone === null || phone === undefined)
            throw new Error("The parameter 'phone' cannot be null.");
        else
            content_.append("phone", phone.toString());
        if (email === null || email === undefined)
            throw new Error("The parameter 'email' cannot be null.");
        else
            content_.append("email", email.toString());
        if (message === null || message === undefined)
            throw new Error("The parameter 'message' cannot be null.");
        else
            content_.append("message", message.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        if (googleRecaptchaResponse === null || googleRecaptchaResponse === undefined)
            throw new Error("The parameter 'googleRecaptchaResponse' cannot be null.");
        else
            content_.append("googleRecaptchaResponse", googleRecaptchaResponse.toString());
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processApplyJob(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplyJob(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processApplyJob(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: JobClient, deps: [{ token: HttpClient }, { token: API_BASE_URL, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: JobClient }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: JobClient, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient, decorators: [{
                    type: Inject,
                    args: [HttpClient]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API_BASE_URL]
                }] }]; } });
class KnowledgeBaseClient {
    constructor(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }
    /**
     * Получить интерпретацию результатов по идентификатору статьи в базе знаний
     * @return Success
     */
    getArticleInterpretationInfo(id) {
        let url_ = this.baseUrl + "/api/knowledgeBase/articles/{id}/interpretationInfo";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetArticleInterpretationInfo(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArticleInterpretationInfo(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetArticleInterpretationInfo(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("No Content", status, _responseText, _headers);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получить статьи в базе знаний по типу
     * @param type Тип статьи в базе знаний
     * @return Success
     */
    getKbItemsList(type) {
        let url_ = this.baseUrl + "/api/knowledgeBase/items/{type}";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetKbItemsList(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKbItemsList(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetKbItemsList(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получить статью об исследовании в базе знаний
     * @param hxid Hxid
     * @param cityId Id города
     * @return Success
     */
    getKbAnalyseItem(hxid, cityId) {
        let url_ = this.baseUrl + "/api/knowledgeBase/analyse/{hxid}/{cityId}";
        if (hxid === undefined || hxid === null)
            throw new Error("The parameter 'hxid' must be defined.");
        url_ = url_.replace("{hxid}", encodeURIComponent("" + hxid));
        if (cityId === undefined || cityId === null)
            throw new Error("The parameter 'cityId' must be defined.");
        url_ = url_.replace("{cityId}", encodeURIComponent("" + cityId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetKbAnalyseItem(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKbAnalyseItem(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetKbAnalyseItem(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status === 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("No Content", status, _responseText, _headers);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получить статью о заболевании или дополнительной статье в базе знаний
     * @param id Id статьи в базе знаний
     * @return Success
     */
    getKbDiseaseItem(id) {
        let url_ = this.baseUrl + "/api/knowledgeBase/disease/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetKbDiseaseItem(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKbDiseaseItem(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetKbDiseaseItem(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status === 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("No Content", status, _responseText, _headers);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получить статью из словаря генетических терминов в базе знаний
     * @param title Название статьи из словаря генетических терминов в базе знаний
     * @return Success
     */
    getKbItem(title) {
        let url_ = this.baseUrl + "/api/knowledgeBase/dict/{title}";
        if (title === undefined || title === null)
            throw new Error("The parameter 'title' must be defined.");
        url_ = url_.replace("{title}", encodeURIComponent("" + title));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetKbItem(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKbItem(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetKbItem(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: KnowledgeBaseClient, deps: [{ token: HttpClient }, { token: API_BASE_URL, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: KnowledgeBaseClient }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: KnowledgeBaseClient, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient, decorators: [{
                    type: Inject,
                    args: [HttpClient]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API_BASE_URL]
                }] }]; } });
class LabomatClient {
    constructor(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }
    /**
     * Получить расположение всех лабоматов в указанном городе
     * @return Success
     */
    getLocations(cityId) {
        let url_ = this.baseUrl + "/api/labomats/{cityId}/locations";
        if (cityId === undefined || cityId === null)
            throw new Error("The parameter 'cityId' must be defined.");
        url_ = url_.replace("{cityId}", encodeURIComponent("" + cityId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetLocations(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocations(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetLocations(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LabomatClient, deps: [{ token: HttpClient }, { token: API_BASE_URL, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LabomatClient }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LabomatClient, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient, decorators: [{
                    type: Inject,
                    args: [HttpClient]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API_BASE_URL]
                }] }]; } });
class LoyaltyClient {
    constructor(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }
    /**
     * Получить информацию о карте лояльности
     * @return Success
     */
    getLoyaltyCardInformation() {
        let url_ = this.baseUrl + "/api/loyalty/card";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetLoyaltyCardInformation(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLoyaltyCardInformation(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetLoyaltyCardInformation(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Привязать к аккаунту карту лояльности
     * @return Success
     */
    bindLoyaltyCard(body) {
        let url_ = this.baseUrl + "/api/loyalty/card/bind";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processBindLoyaltyCard(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBindLoyaltyCard(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processBindLoyaltyCard(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return of(null);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Отвязать карту лояльности от аккаунта
     * @return Success
     */
    removeLoyaltyCard() {
        let url_ = this.baseUrl + "/api/loyalty/card/remove";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({})
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processRemoveLoyaltyCard(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveLoyaltyCard(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processRemoveLoyaltyCard(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return of(null);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получить список операций по карте лояльности
     * @return Success
     */
    getOperations(body) {
        let url_ = this.baseUrl + "/api/loyalty/card/operations";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetOperations(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOperations(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetOperations(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LoyaltyClient, deps: [{ token: HttpClient }, { token: API_BASE_URL, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LoyaltyClient }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LoyaltyClient, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient, decorators: [{
                    type: Inject,
                    args: [HttpClient]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API_BASE_URL]
                }] }]; } });
class MainPageContentClient {
    constructor(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }
    /**
     * Получить коллекцию баннеров по городу
     * @param cityId Id города
     * @return Success
     */
    getBanners(cityId) {
        let url_ = this.baseUrl + "/api/content/main/banners/{cityId}";
        if (cityId === undefined || cityId === null)
            throw new Error("The parameter 'cityId' must be defined.");
        url_ = url_.replace("{cityId}", encodeURIComponent("" + cityId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetBanners(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBanners(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetBanners(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получить коллекцию новостей по городу
     * @param cityId Id города
     * @return Success
     * @deprecated
     */
    getNews(cityId) {
        let url_ = this.baseUrl + "/api/content/main/news/{cityId}";
        if (cityId === undefined || cityId === null)
            throw new Error("The parameter 'cityId' must be defined.");
        url_ = url_.replace("{cityId}", encodeURIComponent("" + cityId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetNews(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNews(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetNews(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status === 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("No Content", status, _responseText, _headers);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получить коллекцию публикаций прессы
     * @return Success
     * @deprecated
     */
    getPublications() {
        let url_ = this.baseUrl + "/api/content/main/publications";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetPublications(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublications(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetPublications(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("No Content", status, _responseText, _headers);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Отправить письмо с вопросом пользователя
     * @param googleRecaptchaResponse (optional)
     * @param cityId (optional)
     * @param name (optional)
     * @param email (optional)
     * @param messageType (optional) Тип сообщения
     * @param message (optional)
     * @param orderCode (optional)
     * @param files (optional)
     * @return Success
     */
    setUserFeedback(googleRecaptchaResponse, cityId, name, email, messageType, message, orderCode, files) {
        let url_ = this.baseUrl + "/api/content/main/feedback";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (googleRecaptchaResponse === null || googleRecaptchaResponse === undefined)
            throw new Error("The parameter 'googleRecaptchaResponse' cannot be null.");
        else
            content_.append("googleRecaptchaResponse", googleRecaptchaResponse.toString());
        if (cityId === null || cityId === undefined)
            throw new Error("The parameter 'cityId' cannot be null.");
        else
            content_.append("cityId", cityId.toString());
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("name", name.toString());
        if (email === null || email === undefined)
            throw new Error("The parameter 'email' cannot be null.");
        else
            content_.append("email", email.toString());
        if (messageType === null || messageType === undefined)
            throw new Error("The parameter 'messageType' cannot be null.");
        else
            content_.append("messageType", messageType.toString());
        if (message === null || message === undefined)
            throw new Error("The parameter 'message' cannot be null.");
        else
            content_.append("message", message.toString());
        if (orderCode === null || orderCode === undefined)
            throw new Error("The parameter 'orderCode' cannot be null.");
        else
            content_.append("orderCode", orderCode.toString());
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files"));
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processSetUserFeedback(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetUserFeedback(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processSetUserFeedback(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return of(null);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Отправить сообщение об ошибке от пользователя
     * @param googleRecaptchaResponse (optional)
     * @param email (optional)
     * @param bugUrl (optional)
     * @param message (optional)
     * @return Success
     */
    setSiteErrorFeedback(googleRecaptchaResponse, email, bugUrl, message) {
        let url_ = this.baseUrl + "/api/content/main/feedback/error";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (googleRecaptchaResponse === null || googleRecaptchaResponse === undefined)
            throw new Error("The parameter 'googleRecaptchaResponse' cannot be null.");
        else
            content_.append("googleRecaptchaResponse", googleRecaptchaResponse.toString());
        if (email === null || email === undefined)
            throw new Error("The parameter 'email' cannot be null.");
        else
            content_.append("email", email.toString());
        if (bugUrl === null || bugUrl === undefined)
            throw new Error("The parameter 'bugUrl' cannot be null.");
        else
            content_.append("bugUrl", bugUrl.toString());
        if (message === null || message === undefined)
            throw new Error("The parameter 'message' cannot be null.");
        else
            content_.append("message", message.toString());
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processSetSiteErrorFeedback(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetSiteErrorFeedback(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processSetSiteErrorFeedback(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return of(null);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MainPageContentClient, deps: [{ token: HttpClient }, { token: API_BASE_URL, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MainPageContentClient }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MainPageContentClient, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient, decorators: [{
                    type: Inject,
                    args: [HttpClient]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API_BASE_URL]
                }] }]; } });
class MobileServiceClient {
    constructor(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }
    /**
     * Получить страницу из cms
     * @return Success
     */
    getMobileServicePage(cityId) {
        let url_ = this.baseUrl + "/api/ms/page/{cityId}";
        if (cityId === undefined || cityId === null)
            throw new Error("The parameter 'cityId' must be defined.");
        url_ = url_.replace("{cityId}", encodeURIComponent("" + cityId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetMobileServicePage(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMobileServicePage(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetMobileServicePage(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Форма обратной связи
     * @return Success
     */
    feedback(body) {
        let url_ = this.baseUrl + "/api/ms/feedback";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processFeedback(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFeedback(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processFeedback(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MobileServiceClient, deps: [{ token: HttpClient }, { token: API_BASE_URL, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MobileServiceClient }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MobileServiceClient, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient, decorators: [{
                    type: Inject,
                    args: [HttpClient]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API_BASE_URL]
                }] }]; } });
class NewsClient {
    constructor(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }
    /**
     * Поиск новостей
     * @param body CityId - обязательное поле.
    Filter - необязательный объект, содержит необязательные поля TagId и NewsDate для фильтрации по тэгу и дате.
    Pagination - необязательный объект, содержит поля Skip и Take для частичного возвращения результата.
     * @return Success
     * @deprecated
     */
    searchNews(body) {
        let url_ = this.baseUrl + "/api/news/search";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processSearchNews(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchNews(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processSearchNews(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Поиск новостей
     * @param filter_tagId (optional)
     * @param filter_newsDate (optional)
     * @param pagination_take (optional)
     * @param pagination_skip (optional)
     * @return Success
     */
    searchNewsV2(cityId, filter_tagId, filter_newsDate, pagination_take, pagination_skip) {
        let url_ = this.baseUrl + "/api/news/search?";
        if (cityId === undefined || cityId === null)
            throw new Error("The parameter 'cityId' must be defined and cannot be null.");
        else
            url_ += "cityId=" + encodeURIComponent("" + cityId) + "&";
        if (filter_tagId === null)
            throw new Error("The parameter 'filter_tagId' cannot be null.");
        else if (filter_tagId !== undefined)
            url_ += "filter.tagId=" + encodeURIComponent("" + filter_tagId) + "&";
        if (filter_newsDate === null)
            throw new Error("The parameter 'filter_newsDate' cannot be null.");
        else if (filter_newsDate !== undefined)
            url_ += "filter.newsDate=" + encodeURIComponent(filter_newsDate ? "" + filter_newsDate.toISOString() : "") + "&";
        if (pagination_take === null)
            throw new Error("The parameter 'pagination_take' cannot be null.");
        else if (pagination_take !== undefined)
            url_ += "pagination.take=" + encodeURIComponent("" + pagination_take) + "&";
        if (pagination_skip === null)
            throw new Error("The parameter 'pagination_skip' cannot be null.");
        else if (pagination_skip !== undefined)
            url_ += "pagination.skip=" + encodeURIComponent("" + pagination_skip) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processSearchNewsV2(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchNewsV2(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processSearchNewsV2(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получить полную модель новости по id
     * @return Success
     */
    getNewsById(id) {
        let url_ = this.baseUrl + "/api/news/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetNewsById(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewsById(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetNewsById(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("No Content", status, _responseText, _headers);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получить тэг по id
     * @return Success
     */
    getTagById(id) {
        let url_ = this.baseUrl + "/api/news/tags/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetTagById(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTagById(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetTagById(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("No Content", status, _responseText, _headers);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получить даты в указанном месяце, в которых были опубликованы новости
     * @param body На вход передается модель.
    CityId - обязательное поле.
    Year - обязательное поле.
    Month - обязательное поле. Нумерация с 1 (Январь - 1, и т д)
     * @return Success
     * @deprecated
     */
    getNewsDates(body) {
        let url_ = this.baseUrl + "/api/news/dates/search";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetNewsDates(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewsDates(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetNewsDates(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получить даты в указанном месяце, в которых были опубликованы новости
     * @return Success
     */
    getNewsDatesV2(year, month, cityId) {
        let url_ = this.baseUrl + "/api/news/dates/search?";
        if (year === undefined || year === null)
            throw new Error("The parameter 'year' must be defined and cannot be null.");
        else
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (month === undefined || month === null)
            throw new Error("The parameter 'month' must be defined and cannot be null.");
        else
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (cityId === undefined || cityId === null)
            throw new Error("The parameter 'cityId' must be defined and cannot be null.");
        else
            url_ += "cityId=" + encodeURIComponent("" + cityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetNewsDatesV2(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewsDatesV2(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetNewsDatesV2(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NewsClient, deps: [{ token: HttpClient }, { token: API_BASE_URL, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NewsClient }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NewsClient, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient, decorators: [{
                    type: Inject,
                    args: [HttpClient]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API_BASE_URL]
                }] }]; } });
class OrderClient {
    constructor(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }
    /**
     * Добавить заказ в историю профиля
    WARNING: Используется в Helix Mobile App
     * @return Success
     */
    addOrderToHistory(orderCode, body) {
        let url_ = this.baseUrl + "/api/orders/{orderCode}/history/add";
        if (orderCode === undefined || orderCode === null)
            throw new Error("The parameter 'orderCode' must be defined.");
        url_ = url_.replace("{orderCode}", encodeURIComponent("" + orderCode));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processAddOrderToHistory(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrderToHistory(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processAddOrderToHistory(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return of(null);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OrderClient, deps: [{ token: HttpClient }, { token: API_BASE_URL, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OrderClient }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OrderClient, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient, decorators: [{
                    type: Inject,
                    args: [HttpClient]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API_BASE_URL]
                }] }]; } });
class OrderResultsClient {
    constructor(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }
    /**
     * Получить список доступных файлов с результатами по заказу
     * @return Success
     */
    getResultsFiles(profileId, orderCode) {
        let url_ = this.baseUrl + "/api/orders/{orderCode}/files?";
        if (orderCode === undefined || orderCode === null)
            throw new Error("The parameter 'orderCode' must be defined.");
        url_ = url_.replace("{orderCode}", encodeURIComponent("" + orderCode));
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined and cannot be null.");
        else
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetResultsFiles(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetResultsFiles(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetResultsFiles(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получить файл с результатами по заказу
     * @return Success
     */
    getResultsFile(profileId, orderCode, labelId) {
        let url_ = this.baseUrl + "/api/orders/{orderCode}/files/results-{labelId}?";
        if (orderCode === undefined || orderCode === null)
            throw new Error("The parameter 'orderCode' must be defined.");
        url_ = url_.replace("{orderCode}", encodeURIComponent("" + orderCode));
        if (labelId === undefined || labelId === null)
            throw new Error("The parameter 'labelId' must be defined.");
        url_ = url_.replace("{labelId}", encodeURIComponent("" + labelId));
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined and cannot be null.");
        else
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetResultsFile(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetResultsFile(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetResultsFile(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return of({ fileName: fileName, data: responseBlob, status: status, headers: _headers });
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получить список доступных файлов с заключениями врача по заказу
     * @return Success
     */
    getComplexConclusionFiles(profileId, orderCode) {
        let url_ = this.baseUrl + "/api/orders/{orderCode}/complexConclusion/files?";
        if (orderCode === undefined || orderCode === null)
            throw new Error("The parameter 'orderCode' must be defined.");
        url_ = url_.replace("{orderCode}", encodeURIComponent("" + orderCode));
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined and cannot be null.");
        else
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetComplexConclusionFiles(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetComplexConclusionFiles(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetComplexConclusionFiles(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получить файл с заключением врача по заказу
     * @return Success
     */
    getComplexConclusionFile(profileId, orderCode, orderItemId) {
        let url_ = this.baseUrl + "/api/orders/{orderCode}/complexConclusion/files/conclusion-{orderItemId}?";
        if (orderCode === undefined || orderCode === null)
            throw new Error("The parameter 'orderCode' must be defined.");
        url_ = url_.replace("{orderCode}", encodeURIComponent("" + orderCode));
        if (orderItemId === undefined || orderItemId === null)
            throw new Error("The parameter 'orderItemId' must be defined.");
        url_ = url_.replace("{orderItemId}", encodeURIComponent("" + orderItemId));
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined and cannot be null.");
        else
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetComplexConclusionFile(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetComplexConclusionFile(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetComplexConclusionFile(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return of({ fileName: fileName, data: responseBlob, status: status, headers: _headers });
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 401) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result401 = null;
                result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OrderResultsClient, deps: [{ token: HttpClient }, { token: API_BASE_URL, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OrderResultsClient }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OrderResultsClient, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient, decorators: [{
                    type: Inject,
                    args: [HttpClient]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API_BASE_URL]
                }] }]; } });
class OrderResultsEmailClient {
    constructor(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }
    /**
     * Отправить результаты заказа на email по профилю
     * @return Success
     */
    sendResultsToEmail(profileId, orderCode, email) {
        let url_ = this.baseUrl + "/api/orders/{orderCode}/files/sendToEmail?";
        if (orderCode === undefined || orderCode === null)
            throw new Error("The parameter 'orderCode' must be defined.");
        url_ = url_.replace("{orderCode}", encodeURIComponent("" + orderCode));
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined and cannot be null.");
        else
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined and cannot be null.");
        else
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processSendResultsToEmail(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendResultsToEmail(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processSendResultsToEmail(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OrderResultsEmailClient, deps: [{ token: HttpClient }, { token: API_BASE_URL, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OrderResultsEmailClient }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OrderResultsEmailClient, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient, decorators: [{
                    type: Inject,
                    args: [HttpClient]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API_BASE_URL]
                }] }]; } });
class OrderV2Client {
    constructor(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }
    /**
     * Получить список заказов и предзаказов по профилю
     * @return Success
     */
    getOrders(profileId) {
        let url_ = this.baseUrl + "/api/v2/orders?";
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined and cannot be null.");
        else
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetOrders(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrders(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetOrders(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получить полную информацию по заказу
     * @return Success
     */
    getOrder(profileId, orderCode) {
        let url_ = this.baseUrl + "/api/v2/orders/{orderCode}?";
        if (orderCode === undefined || orderCode === null)
            throw new Error("The parameter 'orderCode' must be defined.");
        url_ = url_.replace("{orderCode}", encodeURIComponent("" + orderCode));
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined and cannot be null.");
        else
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetOrder(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrder(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetOrder(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Скрыть заказ из профиля
     * @return Success
     */
    hideOrderFromHistory(orderCode, body) {
        let url_ = this.baseUrl + "/api/v2/orders/{orderCode}/history/hide";
        if (orderCode === undefined || orderCode === null)
            throw new Error("The parameter 'orderCode' must be defined.");
        url_ = url_.replace("{orderCode}", encodeURIComponent("" + orderCode));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processHideOrderFromHistory(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHideOrderFromHistory(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processHideOrderFromHistory(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return of(null);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Повторить заказ, если все услуги можно добавить в корзину
     * @return Success
     */
    tryRepeatOrder(orderCode, body) {
        let url_ = this.baseUrl + "/api/v2/orders/{orderCode}/tryRepeat";
        if (orderCode === undefined || orderCode === null)
            throw new Error("The parameter 'orderCode' must be defined.");
        url_ = url_.replace("{orderCode}", encodeURIComponent("" + orderCode));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processTryRepeatOrder(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTryRepeatOrder(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processTryRepeatOrder(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Повторить все услуги из заказа, которые можно добавить в корзину
     * @return Success
     */
    repeatOrder(orderCode, body) {
        let url_ = this.baseUrl + "/api/v2/orders/{orderCode}/repeat";
        if (orderCode === undefined || orderCode === null)
            throw new Error("The parameter 'orderCode' must be defined.");
        url_ = url_.replace("{orderCode}", encodeURIComponent("" + orderCode));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processRepeatOrder(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRepeatOrder(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processRepeatOrder(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return of(null);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OrderV2Client, deps: [{ token: HttpClient }, { token: API_BASE_URL, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OrderV2Client }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: OrderV2Client, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient, decorators: [{
                    type: Inject,
                    args: [HttpClient]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API_BASE_URL]
                }] }]; } });
class PreOrderClient {
    constructor(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }
    /**
     * Получить полную информацию по предзаказу
     * @return Success
     */
    getPreOrder(profileId, preOrderCode, cityId) {
        let url_ = this.baseUrl + "/api/preOrders/{preOrderCode}?";
        if (preOrderCode === undefined || preOrderCode === null)
            throw new Error("The parameter 'preOrderCode' must be defined.");
        url_ = url_.replace("{preOrderCode}", encodeURIComponent("" + preOrderCode));
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined and cannot be null.");
        else
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        if (cityId === undefined || cityId === null)
            throw new Error("The parameter 'cityId' must be defined and cannot be null.");
        else
            url_ += "cityId=" + encodeURIComponent("" + cityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetPreOrder(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPreOrder(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetPreOrder(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получить печатную версию предзаказа
     * @return Success
     */
    getPreOrderPrintVersion(profileId, preOrderCode, cityId) {
        let url_ = this.baseUrl + "/api/preOrders/{preOrderCode}/print?";
        if (preOrderCode === undefined || preOrderCode === null)
            throw new Error("The parameter 'preOrderCode' must be defined.");
        url_ = url_.replace("{preOrderCode}", encodeURIComponent("" + preOrderCode));
        if (profileId === undefined || profileId === null)
            throw new Error("The parameter 'profileId' must be defined and cannot be null.");
        else
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        if (cityId === undefined || cityId === null)
            throw new Error("The parameter 'cityId' must be defined and cannot be null.");
        else
            url_ += "cityId=" + encodeURIComponent("" + cityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetPreOrderPrintVersion(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPreOrderPrintVersion(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetPreOrderPrintVersion(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Скрыть предзаказ из истории пациента
     * @return Success
     */
    hidePreOrderFromHistory(preOrderCode, body) {
        let url_ = this.baseUrl + "/api/preOrders/{preOrderCode}/history/hide";
        if (preOrderCode === undefined || preOrderCode === null)
            throw new Error("The parameter 'preOrderCode' must be defined.");
        url_ = url_.replace("{preOrderCode}", encodeURIComponent("" + preOrderCode));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processHidePreOrderFromHistory(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHidePreOrderFromHistory(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processHidePreOrderFromHistory(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return of(null);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Повторить предзаказ, если все услуги можно добавить в корзину
     * @return Success
     */
    tryRepeatPreOrder(preOrderCode, body) {
        let url_ = this.baseUrl + "/api/preOrders/{preOrderCode}/tryRepeat";
        if (preOrderCode === undefined || preOrderCode === null)
            throw new Error("The parameter 'preOrderCode' must be defined.");
        url_ = url_.replace("{preOrderCode}", encodeURIComponent("" + preOrderCode));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processTryRepeatPreOrder(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTryRepeatPreOrder(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processTryRepeatPreOrder(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Повторить все услуги из предзаказа, которые можно добавить в корзину
     * @return Success
     */
    repeatPreOrder(preOrderCode, body) {
        let url_ = this.baseUrl + "/api/preOrders/{preOrderCode}/repeat";
        if (preOrderCode === undefined || preOrderCode === null)
            throw new Error("The parameter 'preOrderCode' must be defined.");
        url_ = url_.replace("{preOrderCode}", encodeURIComponent("" + preOrderCode));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processRepeatPreOrder(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRepeatPreOrder(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processRepeatPreOrder(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return of(null);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получить количество дней, в течение которых предзаказ отображается в ЛКК
    Данный параметр берется из настроек сайта и конфигурируется через CMS
     * @return Success
     */
    getPreOrderVisibilityDays() {
        let url_ = this.baseUrl + "/api/preOrders/visibilityDays";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetPreOrderVisibilityDays(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPreOrderVisibilityDays(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetPreOrderVisibilityDays(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreOrderClient, deps: [{ token: HttpClient }, { token: API_BASE_URL, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreOrderClient }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreOrderClient, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient, decorators: [{
                    type: Inject,
                    args: [HttpClient]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API_BASE_URL]
                }] }]; } });
class ProfileClient {
    constructor(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }
    /**
     * Возвращает список профилей с полной информацией
     * @return Success
     */
    getFullProfiles() {
        let url_ = this.baseUrl + "/api/profiles/full";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetFullProfiles(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFullProfiles(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetFullProfiles(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status === 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("No Content", status, _responseText, _headers);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Возвращает список всех профилей (пациентов) для пользователя
     * @return Success
     */
    getAllProfiles() {
        let url_ = this.baseUrl + "/api/profiles";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetAllProfiles(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProfiles(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetAllProfiles(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Создать новый профиль
     * @return Success
     */
    createProfile(body) {
        let url_ = this.baseUrl + "/api/profiles";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processCreateProfile(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProfile(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processCreateProfile(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Возвращает список всех профилей (пациентов) для пользователя и баланс лояльности, используя куки с логинАйди
    WARNING: Используется в Helix Mobile App
     * @return Success
     */
    getAccount() {
        let url_ = this.baseUrl + "/api/profiles/account";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetAccount(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccount(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetAccount(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status === 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("No Content", status, _responseText, _headers);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Возвращает выбранный профиль (пациента) для пользователя
     * @return Success
     */
    getCurrentProfile() {
        let url_ = this.baseUrl + "/api/profiles/current";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetCurrentProfile(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentProfile(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetCurrentProfile(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("No Content", status, _responseText, _headers);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Установить нового текущего пользователя
     * @return Success
     */
    setCurrentProfile(body) {
        let url_ = this.baseUrl + "/api/profiles/current";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processSetCurrentProfile(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetCurrentProfile(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processSetCurrentProfile(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("No Content", status, _responseText, _headers);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Обновить данные текущего профиля.
     * @param body (optional) Содержит новые данные
     * @return Success
     */
    updateProfile(body) {
        let url_ = this.baseUrl + "/api/profiles/update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processUpdateProfile(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProfile(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processUpdateProfile(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Удалить профиль
     * @param body (optional)
     * @return Success
     */
    deleteProfile(body) {
        let url_ = this.baseUrl + "/api/profiles/delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processDeleteProfile(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProfile(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processDeleteProfile(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProfileClient, deps: [{ token: HttpClient }, { token: API_BASE_URL, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProfileClient }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProfileClient, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient, decorators: [{
                    type: Inject,
                    args: [HttpClient]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API_BASE_URL]
                }] }]; } });
class PromotionClient {
    constructor(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }
    /**
     * Получить список акций для города
     * @param cityId Id города
     * @param take (optional)
     * @param skip (optional)
     * @return Success
     */
    getListByCity(cityId, take, skip) {
        let url_ = this.baseUrl + "/api/promotions/list/{cityId}?";
        if (cityId === undefined || cityId === null)
            throw new Error("The parameter 'cityId' must be defined.");
        url_ = url_.replace("{cityId}", encodeURIComponent("" + cityId));
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetListByCity(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListByCity(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetListByCity(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получить промо акцию с участвующими в ней центрами данного города по Id
     * @param promotionId Id акции
     * @param cityId Id города
     * @return Success
     */
    getById(promotionId, cityId) {
        let url_ = this.baseUrl + "/api/promotions/id/{promotionId}/{cityId}";
        if (promotionId === undefined || promotionId === null)
            throw new Error("The parameter 'promotionId' must be defined.");
        url_ = url_.replace("{promotionId}", encodeURIComponent("" + promotionId));
        if (cityId === undefined || cityId === null)
            throw new Error("The parameter 'cityId' must be defined.");
        url_ = url_.replace("{cityId}", encodeURIComponent("" + cityId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetById(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetById(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получить список изображений для баннера промо акций
     * @param cityId Id города
     * @return Success
     */
    getImages(cityId) {
        let url_ = this.baseUrl + "/api/promotions/images/{cityId}";
        if (cityId === undefined || cityId === null)
            throw new Error("The parameter 'cityId' must be defined.");
        url_ = url_.replace("{cityId}", encodeURIComponent("" + cityId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetImages(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImages(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetImages(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PromotionClient, deps: [{ token: HttpClient }, { token: API_BASE_URL, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PromotionClient }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PromotionClient, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient, decorators: [{
                    type: Inject,
                    args: [HttpClient]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API_BASE_URL]
                }] }]; } });
class PublicationsClient {
    constructor(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }
    /**
     * Получить наиболее используемые тэги публикаций. По умолчанию (если не передать параметр) - 40
     * @param take (optional) Максимальное кол-во возвращаемых тэгов
     * @return Success
     */
    getPublicationTags(take) {
        let url_ = this.baseUrl + "/api/publications/tags?";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetPublicationTags(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublicationTags(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetPublicationTags(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получить все категории публикаций
     * @return Success
     */
    getPublicationCategories() {
        let url_ = this.baseUrl + "/api/publications/categories";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetPublicationCategories(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublicationCategories(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetPublicationCategories(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Поиск публикаций
     * @return Success
     * @deprecated
     */
    searchPublications(body) {
        let url_ = this.baseUrl + "/api/publications/search";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processSearchPublications(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchPublications(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processSearchPublications(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Поиск публикаций
     * @param filter_publicationTagIds (optional)
     * @param filter_publicationCategoriesIds (optional)
     * @param filter_publisherNameQuery (optional)
     * @param filter_contentQuery (optional)
     * @param filter_fromDate (optional)
     * @param filter_toDate (optional)
     * @param pagination_take (optional)
     * @param pagination_skip (optional)
     * @return Success
     */
    searchPublicationsV2(filter_publicationTagIds, filter_publicationCategoriesIds, filter_publisherNameQuery, filter_contentQuery, filter_fromDate, filter_toDate, pagination_take, pagination_skip) {
        let url_ = this.baseUrl + "/api/publications/search?";
        if (filter_publicationTagIds === null)
            throw new Error("The parameter 'filter_publicationTagIds' cannot be null.");
        else if (filter_publicationTagIds !== undefined)
            filter_publicationTagIds && filter_publicationTagIds.forEach(item => { url_ += "filter.publicationTagIds=" + encodeURIComponent("" + item) + "&"; });
        if (filter_publicationCategoriesIds === null)
            throw new Error("The parameter 'filter_publicationCategoriesIds' cannot be null.");
        else if (filter_publicationCategoriesIds !== undefined)
            filter_publicationCategoriesIds && filter_publicationCategoriesIds.forEach(item => { url_ += "filter.publicationCategoriesIds=" + encodeURIComponent("" + item) + "&"; });
        if (filter_publisherNameQuery === null)
            throw new Error("The parameter 'filter_publisherNameQuery' cannot be null.");
        else if (filter_publisherNameQuery !== undefined)
            url_ += "filter.publisherNameQuery=" + encodeURIComponent("" + filter_publisherNameQuery) + "&";
        if (filter_contentQuery === null)
            throw new Error("The parameter 'filter_contentQuery' cannot be null.");
        else if (filter_contentQuery !== undefined)
            url_ += "filter.contentQuery=" + encodeURIComponent("" + filter_contentQuery) + "&";
        if (filter_fromDate === null)
            throw new Error("The parameter 'filter_fromDate' cannot be null.");
        else if (filter_fromDate !== undefined)
            url_ += "filter.fromDate=" + encodeURIComponent(filter_fromDate ? "" + filter_fromDate.toISOString() : "") + "&";
        if (filter_toDate === null)
            throw new Error("The parameter 'filter_toDate' cannot be null.");
        else if (filter_toDate !== undefined)
            url_ += "filter.toDate=" + encodeURIComponent(filter_toDate ? "" + filter_toDate.toISOString() : "") + "&";
        if (pagination_take === null)
            throw new Error("The parameter 'pagination_take' cannot be null.");
        else if (pagination_take !== undefined)
            url_ += "pagination.take=" + encodeURIComponent("" + pagination_take) + "&";
        if (pagination_skip === null)
            throw new Error("The parameter 'pagination_skip' cannot be null.");
        else if (pagination_skip !== undefined)
            url_ += "pagination.skip=" + encodeURIComponent("" + pagination_skip) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processSearchPublicationsV2(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchPublicationsV2(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processSearchPublicationsV2(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PublicationsClient, deps: [{ token: HttpClient }, { token: API_BASE_URL, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PublicationsClient }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PublicationsClient, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient, decorators: [{
                    type: Inject,
                    args: [HttpClient]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API_BASE_URL]
                }] }]; } });
class SearchClient {
    constructor(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }
    /**
     * @return Success
     */
    search(body) {
        let url_ = this.baseUrl + "/api/search";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processSearch(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processSearch(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Новый поиск, старый контракт
     * @return Success
     */
    searchV2(body) {
        let url_ = this.baseUrl + "/api/search/v2";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processSearchV2(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchV2(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processSearchV2(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Новый поиск (новый универсальный контракт). Пока не используется
     * @param body searchQuery - поисковой запрос
    parameters - массив объектов для поисковых запросов по различным сущностям
    scope: analysis, helixbook, address, promotion (по каким сущностям провести поиск).
    skip, take - пагинация
     * @return Success
     */
    searchV3(body) {
        let url_ = this.baseUrl + "/api/search/v3";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processSearchV3(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchV3(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processSearchV3(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status === 500) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("Server Error", status, _responseText, _headers);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SearchClient, deps: [{ token: HttpClient }, { token: API_BASE_URL, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SearchClient }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SearchClient, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient, decorators: [{
                    type: Inject,
                    args: [HttpClient]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API_BASE_URL]
                }] }]; } });
class SitemapClient {
    constructor(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }
    /**
     * Сгенерировать sitemap-index (содержащий в себе ссылки на все остальные sitemap)
     * @return Success
     */
    sitemapIndex() {
        let url_ = this.baseUrl + "/api/sitemap/sitemapindex";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processSitemapIndex(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSitemapIndex(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processSitemapIndex(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return of({ fileName: fileName, data: responseBlob, status: status, headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Сгенерировать региональный sitemap для города
     * @return Success
     */
    citySitemap(city) {
        let url_ = this.baseUrl + "/api/sitemap/{city}/sitemap";
        if (city === undefined || city === null)
            throw new Error("The parameter 'city' must be defined.");
        url_ = url_.replace("{city}", encodeURIComponent("" + city));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processCitySitemap(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCitySitemap(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processCitySitemap(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return of({ fileName: fileName, data: responseBlob, status: status, headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Сгенерировать sitemap для основных страниц (нерегиональный)
     * @return Success
     */
    pagesSitemap(page) {
        let url_ = this.baseUrl + "/api/sitemap/page/{page}/sitemap";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processPagesSitemap(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPagesSitemap(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processPagesSitemap(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return of({ fileName: fileName, data: responseBlob, status: status, headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SitemapClient, deps: [{ token: HttpClient }, { token: API_BASE_URL, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SitemapClient }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SitemapClient, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient, decorators: [{
                    type: Inject,
                    args: [HttpClient]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API_BASE_URL]
                }] }]; } });
class UserAccountClient {
    constructor(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }
    /**
     * Метод используется для авторизации пользователя из корзины (куки проставляются)
     * @param body (optional) Модель с параметрами для авторизации
     * @return Success
     */
    login(body) {
        let url_ = this.baseUrl + "/api/userAccounts/login";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processLogin(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processLogin(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Метод используется для авторизации пользователя из корзины (куки проставляются)
     * @param body (optional) Модель с параметрами для авторизации
     * @return Success
     */
    forgetPass(body) {
        let url_ = this.baseUrl + "/api/userAccounts/forgetPass";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processForgetPass(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForgetPass(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processForgetPass(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return of(null);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получить текущего пользователя
     * @return Success
     */
    getCurrentAccount() {
        let url_ = this.baseUrl + "/api/userAccounts/me";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetCurrentAccount(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentAccount(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetCurrentAccount(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Сменить пароль у текущего пользователя
     * @return Success
     */
    changePassword(body) {
        let url_ = this.baseUrl + "/api/userAccounts/me/changePassword";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processChangePassword(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processChangePassword(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return of(null);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Сменить email у текущего пользователя
     * @return Success
     */
    changeEmail(body) {
        let url_ = this.baseUrl + "/api/userAccounts/me/changeEmail";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processChangeEmail(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeEmail(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processChangeEmail(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return of(null);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Удалить личный кабинет текущего пользователя
     * @return Success
     */
    deleteAccount() {
        let url_ = this.baseUrl + "/api/userAccounts/me/delete";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processDeleteAccount(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAccount(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processDeleteAccount(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Восстановить личный кабинет текущего пользователя
     * @return Success
     */
    restoreAccount() {
        let url_ = this.baseUrl + "/api/userAccounts/me/restore";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processRestoreAccount(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestoreAccount(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processRestoreAccount(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Получить дополнительный вопрос перед объединением аккаунтов
     * @return Success
     */
    combineAdditionalQuestion(secondaryEmail, secondaryPassword) {
        let url_ = this.baseUrl + "/api/userAccounts/me/combine/additionalQuestion?";
        if (secondaryEmail === undefined || secondaryEmail === null)
            throw new Error("The parameter 'secondaryEmail' must be defined and cannot be null.");
        else
            url_ += "secondaryEmail=" + encodeURIComponent("" + secondaryEmail) + "&";
        if (secondaryPassword === undefined || secondaryPassword === null)
            throw new Error("The parameter 'secondaryPassword' must be defined and cannot be null.");
        else
            url_ += "secondaryPassword=" + encodeURIComponent("" + secondaryPassword) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processCombineAdditionalQuestion(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCombineAdditionalQuestion(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processCombineAdditionalQuestion(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Объединить аккаунты
     * @return Success
     */
    combine(body) {
        let url_ = this.baseUrl + "/api/userAccounts/me/combine";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processCombine(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCombine(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processCombine(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return of(null);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Привязать карту лояльности текущему пользователю
     * @return Success
     */
    addServiceCard(body) {
        let url_ = this.baseUrl + "/api/userAccounts/me/serviceCard";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processAddServiceCard(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddServiceCard(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processAddServiceCard(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return of(null);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Возвращает дополнительные e-mail адреса
     * @return Success
     */
    getAdditionalEmails() {
        let url_ = this.baseUrl + "/api/userAccounts/me/emails";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetAdditionalEmails(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdditionalEmails(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetAdditionalEmails(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("No Content", status, _responseText, _headers);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Возвращает дополнительные номера мобильных телефонов для связи
     * @return Success
     */
    getAdditionalPhones() {
        let url_ = this.baseUrl + "/api/userAccounts/me/phones";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetAdditionalPhones(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdditionalPhones(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetAdditionalPhones(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("No Content", status, _responseText, _headers);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UserAccountClient, deps: [{ token: HttpClient }, { token: API_BASE_URL, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UserAccountClient }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UserAccountClient, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient, decorators: [{
                    type: Inject,
                    args: [HttpClient]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API_BASE_URL]
                }] }]; } });
class UserAccountDataClient {
    constructor(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }
    /**
     * Возвращает список всех избранных (предпочитаемых) центров для пользователя
     * @return Success
     */
    getFavouriteCenters() {
        let url_ = this.baseUrl + "/api/useraccountdata/centers";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetFavouriteCenters(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFavouriteCenters(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetFavouriteCenters(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Добавляет центр в избранные
     * @return Success
     */
    addFavouriteCenter(body) {
        let url_ = this.baseUrl + "/api/useraccountdata/centers/add";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processAddFavouriteCenter(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddFavouriteCenter(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processAddFavouriteCenter(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Удаляет центр из избранных
     * @return Success
     */
    deleteFavouriteCenter(body) {
        let url_ = this.baseUrl + "/api/useraccountdata/centers/delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processDeleteFavouriteCenter(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFavouriteCenter(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processDeleteFavouriteCenter(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Возвращает сохранённые адреса для вызова мобильной службы
     * @return Success
     */
    getMobileServiceAddresses() {
        let url_ = this.baseUrl + "/api/useraccountdata/addresses";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(mergeMap((response_) => {
            return this.processGetMobileServiceAddresses(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMobileServiceAddresses(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processGetMobileServiceAddresses(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("No Content", status, _responseText, _headers);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Добавляет адрес для выезда мобильной службы
     * @return Success
     */
    addAddress(body) {
        let url_ = this.baseUrl + "/api/useraccountdata/addresses/add";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processAddAddress(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAddress(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processAddAddress(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Обновляет адрес для выезда мобильной службы
     * @return Success
     */
    updateAddress(body) {
        let url_ = this.baseUrl + "/api/useraccountdata/addresses/update";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processUpdateAddress(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAddress(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processUpdateAddress(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    /**
     * Удаляет адрес для выезда мобильной службы
     * @return Success
     */
    deleteAddress(body) {
        let url_ = this.baseUrl + "/api/useraccountdata/addresses/delete";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(mergeMap((response_) => {
            return this.processDeleteAddress(response_);
        })).pipe(catchError((response_) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAddress(response_);
                }
                catch (e) {
                    return throwError(e);
                }
            }
            else
                return throwError(response_);
        }));
    }
    processDeleteAddress(response) {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body : response?.error;
        let _headers = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return of(result200);
            }));
        }
        else if (status === 400) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result400 = null;
                result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 403) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result403 = null;
                result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        }
        else if (status === 409) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                let result409 = null;
                result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UserAccountDataClient, deps: [{ token: HttpClient }, { token: API_BASE_URL, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UserAccountDataClient }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UserAccountDataClient, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient, decorators: [{
                    type: Inject,
                    args: [HttpClient]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API_BASE_URL]
                }] }]; } });
var CacheTypes;
(function (CacheTypes) {
    CacheTypes["CatalogGroups"] = "CatalogGroups";
    CacheTypes["Cities"] = "Cities";
    CacheTypes["Centers"] = "Centers";
    CacheTypes["IdentityToken"] = "IdentityToken";
    CacheTypes["Labomats"] = "Labomats";
    CacheTypes["NewsPublications"] = "NewsPublications";
    CacheTypes["PopularItems"] = "PopularItems";
    CacheTypes["Promotions"] = "Promotions";
    CacheTypes["SiteSettings"] = "SiteSettings";
    CacheTypes["KnowledgeBase"] = "KnowledgeBase";
})(CacheTypes || (CacheTypes = {}));
/** Перечисление типов записи на услугу */
var AppointmentServiceType;
(function (AppointmentServiceType) {
    AppointmentServiceType["Default"] = "Default";
    AppointmentServiceType["Ct"] = "Ct";
    AppointmentServiceType["Mri"] = "Mri";
    AppointmentServiceType["Vaccination"] = "Vaccination";
    AppointmentServiceType["Covid"] = "Covid";
    AppointmentServiceType["DoublePcr"] = "DoublePcr";
})(AppointmentServiceType || (AppointmentServiceType = {}));
var EnterStatus;
(function (EnterStatus) {
    EnterStatus["SuchUserNotRegisteredAsClient"] = "SuchUserNotRegisteredAsClient";
    EnterStatus["AccountNotActivated"] = "AccountNotActivated";
    EnterStatus["UserWithSuchEmailAndPasswordNotFound"] = "UserWithSuchEmailAndPasswordNotFound";
})(EnterStatus || (EnterStatus = {}));
/** Тип hxid-а */
var CartItemType;
(function (CartItemType) {
    CartItemType["Analyse"] = "Analyse";
    CartItemType["Complex"] = "Complex";
    CartItemType["Service"] = "Service";
})(CartItemType || (CartItemType = {}));
/** Перечисление, описывающее пол клиента */
var ClientGender;
(function (ClientGender) {
    ClientGender["Male"] = "Male";
    ClientGender["Female"] = "Female";
    ClientGender["None"] = "None";
})(ClientGender || (ClientGender = {}));
/** Статус попытки добавления элемента в корзину */
var CartItemResultStatus;
(function (CartItemResultStatus) {
    CartItemResultStatus["Error"] = "Error";
    CartItemResultStatus["Added"] = "Added";
    CartItemResultStatus["Duplicate"] = "Duplicate";
    CartItemResultStatus["InComplex"] = "InComplex";
    CartItemResultStatus["RedirectToInformationPage"] = "RedirectToInformationPage";
})(CartItemResultStatus || (CartItemResultStatus = {}));
var NomenclatureGroup;
(function (NomenclatureGroup) {
    NomenclatureGroup["Default"] = "Default";
    NomenclatureGroup["Covid19"] = "Covid19";
    NomenclatureGroup["Antibodies"] = "Antibodies";
    NomenclatureGroup["Vaccination"] = "Vaccination";
    NomenclatureGroup["AfterCovid19"] = "AfterCovid19";
    NomenclatureGroup["ImmuneStatus"] = "ImmuneStatus";
})(NomenclatureGroup || (NomenclatureGroup = {}));
var PreorderAvailabilityStatus;
(function (PreorderAvailabilityStatus) {
    PreorderAvailabilityStatus["Available"] = "Available";
    PreorderAvailabilityStatus["OnlyInDiagnosticCenter"] = "OnlyInDiagnosticCenter";
    PreorderAvailabilityStatus["NotAvailable"] = "NotAvailable";
    PreorderAvailabilityStatus["MobileService"] = "MobileService";
    PreorderAvailabilityStatus["Appointment"] = "Appointment";
})(PreorderAvailabilityStatus || (PreorderAvailabilityStatus = {}));
/** Перечисление описывает возможные ошибки бизнес-логики, которые необходимо отобразить пользователю в виде понятного сообщения */
var BusinessLogicStatus;
(function (BusinessLogicStatus) {
    BusinessLogicStatus["CityIdNotFound"] = "CityIdNotFound";
    BusinessLogicStatus["CannotCreateOrder"] = "CannotCreateOrder";
    BusinessLogicStatus["CannotGetInvoice"] = "CannotGetInvoice";
    BusinessLogicStatus["CannotCreateInvoice"] = "CannotCreateInvoice";
    BusinessLogicStatus["ProfileNotExists"] = "ProfileNotExists";
    BusinessLogicStatus["RecaptchaRequestFromBot"] = "RecaptchaRequestFromBot";
    BusinessLogicStatus["InvalidFileExtension"] = "InvalidFileExtension";
    BusinessLogicStatus["SumFileSizeExceedsMaxValue"] = "SumFileSizeExceedsMaxValue";
    BusinessLogicStatus["WebAccountNotFound"] = "WebAccountNotFound";
    BusinessLogicStatus["CityNameNotFound"] = "CityNameNotFound";
    BusinessLogicStatus["SomeItemFromCartMissingFromDb"] = "SomeItemFromCartMissingFromDb";
    BusinessLogicStatus["NotDiagnosticCenterIsAvailableForCartWithSelectedPaymentType"] = "NotDiagnosticCenterIsAvailableForCartWithSelectedPaymentType";
    BusinessLogicStatus["CartNotFoundOrDeleted"] = "CartNotFoundOrDeleted";
    BusinessLogicStatus["ReturnToFirstStepAndChooseAnyBiomaterial"] = "ReturnToFirstStepAndChooseAnyBiomaterial";
    BusinessLogicStatus["CartHasAnotherPaymentType"] = "CartHasAnotherPaymentType";
    BusinessLogicStatus["IncorrectRevision"] = "IncorrectRevision";
    BusinessLogicStatus["AnyProfileRequiredInAccount"] = "AnyProfileRequiredInAccount";
    BusinessLogicStatus["UserAccountNotFound"] = "UserAccountNotFound";
    BusinessLogicStatus["CartMustContainClientsData"] = "CartMustContainClientsData";
    BusinessLogicStatus["ChooseOfflinePaymentType"] = "ChooseOfflinePaymentType";
    BusinessLogicStatus["ProfileNotFound"] = "ProfileNotFound";
    BusinessLogicStatus["OrderHasAlreadyBeenSaved"] = "OrderHasAlreadyBeenSaved";
    BusinessLogicStatus["ChooseClientProfile"] = "ChooseClientProfile";
    BusinessLogicStatus["EmailAndPhoneRequiredToOnlinePayment"] = "EmailAndPhoneRequiredToOnlinePayment";
    BusinessLogicStatus["CovidRedirectRu"] = "CovidRedirectRu";
    BusinessLogicStatus["CovidRedirectKz"] = "CovidRedirectKz";
    BusinessLogicStatus["MobileServiceNotFound"] = "MobileServiceNotFound";
    BusinessLogicStatus["KbItemNotFound"] = "KbItemNotFound";
    BusinessLogicStatus["NomenclatureNotFound"] = "NomenclatureNotFound";
    BusinessLogicStatus["CityDoesNotMatch"] = "CityDoesNotMatch";
    BusinessLogicStatus["CityFiasCodeIsNotValid"] = "CityFiasCodeIsNotValid";
})(BusinessLogicStatus || (BusinessLogicStatus = {}));
/** Перечисление описывает возможные коды ошибок при валидации данных */
var CommonValidationStatus;
(function (CommonValidationStatus) {
    CommonValidationStatus["Required"] = "Required";
    CommonValidationStatus["TooLarge"] = "TooLarge";
    CommonValidationStatus["TooShort"] = "TooShort";
    CommonValidationStatus["InvalidFormat"] = "InvalidFormat";
    CommonValidationStatus["DateCannotBeInFuture"] = "DateCannotBeInFuture";
    CommonValidationStatus["DateMustBeGreaterThanNow"] = "DateMustBeGreaterThanNow";
    CommonValidationStatus["DateMustBeGreaterOrEqualToday"] = "DateMustBeGreaterOrEqualToday";
    CommonValidationStatus["ValueMustBeGreaterThanZero"] = "ValueMustBeGreaterThanZero";
    CommonValidationStatus["IncorrectDateInterval"] = "IncorrectDateInterval";
    CommonValidationStatus["ValueMustBeGreaterThanOrEqualToZero"] = "ValueMustBeGreaterThanOrEqualToZero";
})(CommonValidationStatus || (CommonValidationStatus = {}));
/** Общее перечисление, описывающее пол клиента. */
var Gender;
(function (Gender) {
    Gender["Male"] = "Male";
    Gender["Female"] = "Female";
})(Gender || (Gender = {}));
var YandexMapsLocale;
(function (YandexMapsLocale) {
    YandexMapsLocale["Ru_RU"] = "ru_RU";
    YandexMapsLocale["Ru_UA"] = "ru_UA";
    YandexMapsLocale["En_US"] = "en_US";
    YandexMapsLocale["En_RU"] = "en_RU";
    YandexMapsLocale["Uk_UA"] = "uk_UA";
    YandexMapsLocale["Tr_TR"] = "tr_TR";
})(YandexMapsLocale || (YandexMapsLocale = {}));
var DynamicsResultStatus;
(function (DynamicsResultStatus) {
    DynamicsResultStatus["Numeric"] = "Numeric";
    DynamicsResultStatus["Text"] = "Text";
})(DynamicsResultStatus || (DynamicsResultStatus = {}));
/** Источник сообщения */
var UserFeedbackMessageSource;
(function (UserFeedbackMessageSource) {
    UserFeedbackMessageSource["Site"] = "Site";
    UserFeedbackMessageSource["My"] = "My";
})(UserFeedbackMessageSource || (UserFeedbackMessageSource = {}));
/** Тип сообщения */
var UserFeedbackMessageType;
(function (UserFeedbackMessageType) {
    UserFeedbackMessageType["Question"] = "Question";
    UserFeedbackMessageType["Proposal"] = "Proposal";
    UserFeedbackMessageType["Complaint"] = "Complaint";
    UserFeedbackMessageType["Gratitude"] = "Gratitude";
    UserFeedbackMessageType["IssuingCertificate"] = "IssuingCertificate";
})(UserFeedbackMessageType || (UserFeedbackMessageType = {}));
var SendInterviewError;
(function (SendInterviewError) {
    SendInterviewError["Unauthorized"] = "Unauthorized";
})(SendInterviewError || (SendInterviewError = {}));
var KbItemType;
(function (KbItemType) {
    KbItemType["Analyse"] = "Analyse";
    KbItemType["Disease"] = "Disease";
    KbItemType["GeneticDictionary"] = "GeneticDictionary";
})(KbItemType || (KbItemType = {}));
/** Тип операций по карте */
var LoyaltyCardOperationType;
(function (LoyaltyCardOperationType) {
    LoyaltyCardOperationType["All"] = "All";
    LoyaltyCardOperationType["Debet"] = "Debet";
    LoyaltyCardOperationType["Credit"] = "Credit";
})(LoyaltyCardOperationType || (LoyaltyCardOperationType = {}));
var LoyaltyCardStatus;
(function (LoyaltyCardStatus) {
    LoyaltyCardStatus["NotActivated"] = "NotActivated";
    LoyaltyCardStatus["Activated"] = "Activated";
    LoyaltyCardStatus["Disabled"] = "Disabled";
    LoyaltyCardStatus["NotSet"] = "NotSet";
    LoyaltyCardStatus["Error"] = "Error";
})(LoyaltyCardStatus || (LoyaltyCardStatus = {}));
/** Тип сообщения */
var UserFeedbackMessageType2;
(function (UserFeedbackMessageType2) {
    UserFeedbackMessageType2["Question"] = "Question";
    UserFeedbackMessageType2["Proposal"] = "Proposal";
    UserFeedbackMessageType2["Complaint"] = "Complaint";
    UserFeedbackMessageType2["Gratitude"] = "Gratitude";
    UserFeedbackMessageType2["IssuingCertificate"] = "IssuingCertificate";
})(UserFeedbackMessageType2 || (UserFeedbackMessageType2 = {}));
var GetComplexConclusionFilesError;
(function (GetComplexConclusionFilesError) {
    GetComplexConclusionFilesError["Unauthorized"] = "Unauthorized";
})(GetComplexConclusionFilesError || (GetComplexConclusionFilesError = {}));
var GetResultsFilesError;
(function (GetResultsFilesError) {
    GetResultsFilesError["Unauthorized"] = "Unauthorized";
})(GetResultsFilesError || (GetResultsFilesError = {}));
var RepeatOrderError;
(function (RepeatOrderError) {
    RepeatOrderError["Unauthorized"] = "Unauthorized";
})(RepeatOrderError || (RepeatOrderError = {}));
var SendResultsToEmailByProfileError;
(function (SendResultsToEmailByProfileError) {
    SendResultsToEmailByProfileError["Unauthorized"] = "Unauthorized";
})(SendResultsToEmailByProfileError || (SendResultsToEmailByProfileError = {}));
var SendResultsToEmailByProfileResponseType;
(function (SendResultsToEmailByProfileResponseType) {
    SendResultsToEmailByProfileResponseType["Success"] = "Success";
    SendResultsToEmailByProfileResponseType["SuccessAndHasConfirmedHiv"] = "SuccessAndHasConfirmedHiv";
    SendResultsToEmailByProfileResponseType["HasConfirmedHiv"] = "HasConfirmedHiv";
    SendResultsToEmailByProfileResponseType["Cancelled"] = "Cancelled";
    SendResultsToEmailByProfileResponseType["NotReady"] = "NotReady";
    SendResultsToEmailByProfileResponseType["NotFound"] = "NotFound";
})(SendResultsToEmailByProfileResponseType || (SendResultsToEmailByProfileResponseType = {}));
var TryRepeatOrderError;
(function (TryRepeatOrderError) {
    TryRepeatOrderError["Unauthorized"] = "Unauthorized";
})(TryRepeatOrderError || (TryRepeatOrderError = {}));
var TryRepeatOrderResponseType;
(function (TryRepeatOrderResponseType) {
    TryRepeatOrderResponseType["ItemsAdded"] = "ItemsAdded";
    TryRepeatOrderResponseType["AllItemsUnavailable"] = "AllItemsUnavailable";
    TryRepeatOrderResponseType["AllItemsAlreadyInCart"] = "AllItemsAlreadyInCart";
    TryRepeatOrderResponseType["HasUnavailableItems"] = "HasUnavailableItems";
    TryRepeatOrderResponseType["CartHasItems"] = "CartHasItems";
    TryRepeatOrderResponseType["HasAppointmentRequiredItems"] = "HasAppointmentRequiredItems";
    TryRepeatOrderResponseType["HasAppointmentRequiredItemsAndRepeatableItems"] = "HasAppointmentRequiredItemsAndRepeatableItems";
})(TryRepeatOrderResponseType || (TryRepeatOrderResponseType = {}));
var GetOrderApiResponseTypeV2;
(function (GetOrderApiResponseTypeV2) {
    GetOrderApiResponseTypeV2["Draft"] = "Draft";
    GetOrderApiResponseTypeV2["Results"] = "Results";
    GetOrderApiResponseTypeV2["OrderHasConfirmedHiv"] = "OrderHasConfirmedHiv";
    GetOrderApiResponseTypeV2["AllOrderItemsAreServices"] = "AllOrderItemsAreServices";
    GetOrderApiResponseTypeV2["OrderResultsAreNotReady"] = "OrderResultsAreNotReady";
})(GetOrderApiResponseTypeV2 || (GetOrderApiResponseTypeV2 = {}));
var GetOrderErrorV2;
(function (GetOrderErrorV2) {
    GetOrderErrorV2["Unauthorized"] = "Unauthorized";
})(GetOrderErrorV2 || (GetOrderErrorV2 = {}));
var HideOrderFromHistoryErrorV2;
(function (HideOrderFromHistoryErrorV2) {
    HideOrderFromHistoryErrorV2["Unauthorized"] = "Unauthorized";
})(HideOrderFromHistoryErrorV2 || (HideOrderFromHistoryErrorV2 = {}));
var OrderStatusV2;
(function (OrderStatusV2) {
    OrderStatusV2["Unknown"] = "Unknown";
    OrderStatusV2["Created"] = "Created";
    OrderStatusV2["Paid"] = "Paid";
    OrderStatusV2["PaymentAwaiting"] = "PaymentAwaiting";
    OrderStatusV2["Confirmed"] = "Confirmed";
    OrderStatusV2["InProgress"] = "InProgress";
    OrderStatusV2["Cancelled"] = "Cancelled";
    OrderStatusV2["Completed"] = "Completed";
})(OrderStatusV2 || (OrderStatusV2 = {}));
var GetPreOrderError;
(function (GetPreOrderError) {
    GetPreOrderError["Unauthorized"] = "Unauthorized";
})(GetPreOrderError || (GetPreOrderError = {}));
/** Тип ответа на запрос получения печатной версии предзаказа */
var GetPreOrderPrintResponseType;
(function (GetPreOrderPrintResponseType) {
    GetPreOrderPrintResponseType["PreOrderHtml"] = "PreOrderHtml";
    GetPreOrderPrintResponseType["NotAvailableInRegion"] = "NotAvailableInRegion";
})(GetPreOrderPrintResponseType || (GetPreOrderPrintResponseType = {}));
var GetPreOrderPrintVersionError;
(function (GetPreOrderPrintVersionError) {
    GetPreOrderPrintVersionError["Unauthorized"] = "Unauthorized";
})(GetPreOrderPrintVersionError || (GetPreOrderPrintVersionError = {}));
var HidePreOrderFromHistoryError;
(function (HidePreOrderFromHistoryError) {
    HidePreOrderFromHistoryError["Unauthorized"] = "Unauthorized";
})(HidePreOrderFromHistoryError || (HidePreOrderFromHistoryError = {}));
var RepeatOrderError2;
(function (RepeatOrderError2) {
    RepeatOrderError2["Unauthorized"] = "Unauthorized";
})(RepeatOrderError2 || (RepeatOrderError2 = {}));
var TryRepeatOrderError2;
(function (TryRepeatOrderError2) {
    TryRepeatOrderError2["Unauthorized"] = "Unauthorized";
})(TryRepeatOrderError2 || (TryRepeatOrderError2 = {}));
var PromotionStatus;
(function (PromotionStatus) {
    PromotionStatus["Active"] = "Active";
    PromotionStatus["Expired"] = "Expired";
    PromotionStatus["Disabled"] = "Disabled";
})(PromotionStatus || (PromotionStatus = {}));
var SitemapPage;
(function (SitemapPage) {
    SitemapPage["Main"] = "Main";
    SitemapPage["StaticPages"] = "StaticPages";
    SitemapPage["Kb"] = "Kb";
    SitemapPage["Centers"] = "Centers";
})(SitemapPage || (SitemapPage = {}));
var ChangePasswordError;
(function (ChangePasswordError) {
    ChangePasswordError["WrongOldPassword"] = "WrongOldPassword";
    ChangePasswordError["NotStrongEnoughPassword"] = "NotStrongEnoughPassword";
})(ChangePasswordError || (ChangePasswordError = {}));
var CombineAdditionalQuestionResponseType;
(function (CombineAdditionalQuestionResponseType) {
    CombineAdditionalQuestionResponseType["None"] = "None";
    CombineAdditionalQuestionResponseType["ReplaceCard"] = "ReplaceCard";
    CombineAdditionalQuestionResponseType["MoveCard"] = "MoveCard";
})(CombineAdditionalQuestionResponseType || (CombineAdditionalQuestionResponseType = {}));
var ForgetPassError;
(function (ForgetPassError) {
    ForgetPassError["SuchUserNotRegisteredAsClient"] = "SuchUserNotRegisteredAsClient";
    ForgetPassError["SuchUserNotRegistered"] = "SuchUserNotRegistered";
})(ForgetPassError || (ForgetPassError = {}));
var LoginResultStatus;
(function (LoginResultStatus) {
    LoginResultStatus["Success"] = "Success";
    LoginResultStatus["AlreadyLoggedIn"] = "AlreadyLoggedIn";
})(LoginResultStatus || (LoginResultStatus = {}));
/** Пол */
var Gender2;
(function (Gender2) {
    Gender2["Male"] = "Male";
    Gender2["Female"] = "Female";
})(Gender2 || (Gender2 = {}));
var CacheStatus;
(function (CacheStatus) {
    CacheStatus["Started"] = "Started";
    CacheStatus["Reseted"] = "Reseted";
    CacheStatus["Adjusted"] = "Adjusted";
    CacheStatus["Retried"] = "Retried";
    CacheStatus["Disabled"] = "Disabled";
    CacheStatus["Stopped"] = "Stopped";
})(CacheStatus || (CacheStatus = {}));
var AccountPaymentStatus;
(function (AccountPaymentStatus) {
    AccountPaymentStatus["Accept"] = "Accept";
    AccountPaymentStatus["Decline"] = "Decline";
    AccountPaymentStatus["Unknown"] = "Unknown";
    AccountPaymentStatus["Custom"] = "Custom";
})(AccountPaymentStatus || (AccountPaymentStatus = {}));
var PaymentType;
(function (PaymentType) {
    PaymentType["Offline"] = "Offline";
    PaymentType["Online"] = "Online";
})(PaymentType || (PaymentType = {}));
var SearchEngineIndex;
(function (SearchEngineIndex) {
    SearchEngineIndex["Analysis"] = "Analysis";
    SearchEngineIndex["Helixbook"] = "Helixbook";
    SearchEngineIndex["Address"] = "Address";
    SearchEngineIndex["Promotion"] = "Promotion";
})(SearchEngineIndex || (SearchEngineIndex = {}));
class ApiException extends Error {
    constructor(message, status, response, headers, result) {
        super();
        this.isApiException = true;
        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }
    static isApiException(obj) {
        return obj.isApiException === true;
    }
}
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        return throwError(result);
    else
        return throwError(new ApiException(message, status, response, headers, null));
}
function blobToText(blob) {
    return new Observable((observer) => {
        observer.next(JSON.stringify(blob));
        observer.complete();
    });
}

/*
 * Public API Surface of helixru-web-api
 */

/**
 * Generated bundle index. Do not edit.
 */

export { API_BASE_URL, AccountPaymentStatus, ApiException, AppointmentClient, AppointmentServiceType, AuthorizationClient, B2BClient, BusinessClient, BusinessLogicStatus, CacheClient, CacheStatus, CacheTypes, CartClient, CartItemResultStatus, CartItemType, CatalogClient, CentersClient, ChangePasswordError, CitiesClient, ClientGender, CombineAdditionalQuestionResponseType, CommonValidationStatus, ConfigurationClient, DictionaryClient, DynamicsClient, DynamicsResultStatus, EnterStatus, FeedbackClient, ForgetPassError, Gender, Gender2, GetComplexConclusionFilesError, GetOrderApiResponseTypeV2, GetOrderErrorV2, GetPreOrderError, GetPreOrderPrintResponseType, GetPreOrderPrintVersionError, GetResultsFilesError, HideOrderFromHistoryErrorV2, HidePreOrderFromHistoryError, InterviewClient, JobClient, KbItemType, KnowledgeBaseClient, LabomatClient, LoginResultStatus, LoyaltyCardOperationType, LoyaltyCardStatus, LoyaltyClient, MainPageContentClient, MobileServiceClient, NewsClient, NomenclatureGroup, OrderClient, OrderResultsClient, OrderResultsEmailClient, OrderStatusV2, OrderV2Client, PaymentType, PreOrderClient, PreorderAvailabilityStatus, ProfileClient, PromotionClient, PromotionStatus, PublicationsClient, RepeatOrderError, RepeatOrderError2, SearchClient, SearchEngineIndex, SendInterviewError, SendResultsToEmailByProfileError, SendResultsToEmailByProfileResponseType, SitemapClient, SitemapPage, TryRepeatOrderError, TryRepeatOrderError2, TryRepeatOrderResponseType, UserAccountClient, UserAccountDataClient, UserFeedbackMessageSource, UserFeedbackMessageType, UserFeedbackMessageType2, YandexMapsLocale };
